/* eslint-disable no-undef */
/* eslint-disable no-constant-condition */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Fragment, useCallback, useEffect, useState } from 'react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone'
import { v4 as uuidv4 } from 'uuid';
import { Button, InputLabel, RadioGroup, Radio, Table, TableBody, TableContainer, Paper, Grid, Checkbox, FormControlLabel, Box } from '@mui/material';
import { TextField, SelectField, Dialog } from '../../style-guide';
import './Personal.scss';
import PaymentDetails from './PaymentDetails';
import PaymentDetailsNew from './PaymentDetailsNew';
import { setCookie, getCookie } from '../../utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import { getSession, setSelectedShipping } from '../../reducers/user-reducers/UserSlicer';
import { snackbarToggle, snackbarAutoClose } from '../../reducers/snackbarSlicer';
import { FaWindowClose } from "react-icons/fa";
import { getShippingRequest, getStorageSettings, getAdditionalCostForCalc, getShipmentCost, getBase64RecieptList, deleteReciept, getCouponValue1, isValidCoupon, getCouponList, validateHebrewText, validatePhone, listWarehouse, getExchangeRate, saveProfile, cardTextFromNumber, cardFromType, checkCvvAndNumber, cardFromNumber, validateMonth, validateYear, validateCardNumber, validateDigits, validateMyId, getCityStreetNcode, getZigZagAddresses, registerUser, ping, validateEmail, copyToClipboard1, shipping_upload, shipping_upload_again, shippingDelivaryRequestPay, shippingDelivaryRequestPayWithToken, setUserData, getETAStatus } from '../../reducers/requestHandler';
import { settingsRedbox, weightAndVal, cc_months, cc_years, shippingCoPoints } from '../../constants/global-constants';
import CloseIcon from '@mui/icons-material/Close';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import copy from '../../images/copy.png'
import upload from '../../images/upload.png'
import file from '../../images/file.png'
import del from '../../images/del.jpg'
import RedBoxBg from '../../images/box-background-img.png'
import CcCardImg from '../../images/cc-img-center.png'

import questionMark from '../../images/question-mark.png'
import checkMarkCopy from '../../images/check-mark-copy.png'
import DialogWithSideBar from '../../style-guide/Dialog/DialogWithSideBar';
import Loader from '../../style-guide/Loader';
import ActionButton from '../Common/ActionButton';
import DoneIcon from '@mui/icons-material/Done';
import { FaCheckCircle, FaCheck, FaWifi, } from "react-icons/fa";
import ClearIcon from '@mui/icons-material/Clear';
import { chWtMultiplier } from '../../constants/global-constants';
import addresses_cities from '../res.json';
import addresses_cities_csv from '../res.csv';

import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


var tokenFlag = false;
var tempCityId = null;
var tempStreetId = null;
var tempBuildingId = null;

const screens = [{ id: 1, screen: 1, title: 'העלאת חשבונית' }, { id: 2, screen: 2, title: 'השלמת פרטי משלוח' }, { id: 3, screen: 3, title: 'תשלום' }];
const screensMulti = [{ id: 1, screen: 1, title: 'העלאת חשבוניות' }, { id: 2, screen: 2, title: 'השלמת פרטי משלוח' }, { id: 3, screen: 3, title: 'תשלום' }];
const months = [{ id: 1, name: "חודש" }];
const sleeps = [{ id: 1, name: "שנה" }];
const currencies = [{ id: 1, name: "$ דולר", symbol: "$" }, { id: 2, name: "€ אירו", symbol: "€" }, { id: 3, name: "£ פאונד", symbol: "£" }, { id: 4, name: "zł זלוטי", symbol: "zł" }, { id: 5, name: "C$ דולר קנדי", symbol: "C$" }];
const otpArr = [{ id: 1, val: "1" }, { id: 2, val: "2" }, { id: 3, val: "3" }, { id: 4, val: "4" }, { id: 5, val: "5" }, { id: 6, val: "6" }];
const personals = [{
    id: 1, val: "1", name: "Ofer Milkin", addLine1: "Nashua, NH, 03063", addLine2: ".472 Amherst St", city: "Nashua", state: "NH", zipCode: "03063", phone: "781-491-0874"
}, {
    id: 2, val: "2", name: "Ofer Milkin", addLine1: "Nashua, NH, 03063", addLine2: ".472 Amherst St", city: "Nashua", state: "NH", zipCode: "03063", phone: "781-491-0874"
}, { id: 3, val: "3", name: "Ofer Milkin", addLine1: "Nashua, NH, 03063", addLine2: ".472 Amherst St", city: "Nashua", state: "NH", zipCode: "03063", phone: "781-491-0874" }];

const data = {
    cirtificateList: [{ id: 1, name: "כן" }, { id: 2, name:"לא"}],
    selectedCurrency: currencies[0].id,
    selectedMonth: 0,//cc_months[0].id,
    selectedYear: 0,//cc_years[0].id,
    certificateId: 1,
    costOfItem: 0,
    totalCost: 0,
    invoiceOriginal: 0,
    orgTotalCost: 0,
    totalInvoice: 0,
    weight: 0,
    transportVal: 0,
    cif: 0,
    cD: 0,
    customsCharge: 0,
    insurence: 0,
    purchaseTax: 0,
    vat: 0,
    isCertificate: true,
    isInsurence: null,
    homeDelivary: true,
    mycvv: '',
    ccno: '',
    cctype: '',
    myid: '',
    cc_name: '',
    profileId: '',
    otp: '',
    nickName: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: '',
    companyName: '',
    hpAuth: '',
    isCoupon: false,
    payByToken: false,
    rememberPayment: true,
    isTnc: false,
    countryCode: '',
    addressLine_1: '',
    addressLine_2: '',
    state: '',
    city: '',
    couponText: '',
    postal: '',
    cityId: 0,
    streetId: 0,
    buildingId: 0,
    ncodeId: 0,
    addCharges: 0,
    cityNum: '',
    addName: '',
    addPhone: '',
    buildingNum: '',
    ncodeNum: '',
    streetNum: '',
}

export const Personal = (props) => {
    const { isPersonal, setIsPersonal, shipping, get_shipping_list_count, calculateValues } = props;
    const { userInfo, selectedShipping } = useSelector(state => state.user);
    const [couponList, setCouponList] = new useState([]);
    const [wareHouses, setWareHouses] = new useState([]);
    const [value, setValue] = useState(data);
    const [isInsurenceDisabled, setInsurenceDisabled] = useState(false);
    const [inValidMyId, setInValidMyId] = useState(false);
    const [inValidCard, setInValidCard] = useState(false);
    const [inValidCcName, setinValidCcName] = useState(false);
    const [activeScreen, setActiveScreen] = useState(1);
    const [uploadedPdfFileName, setUploadedPdfFileName] = useState("");
    const [uploadedPdf, setUploadedPdf] = useState("");
    const [uploadedPdfBse64, setUploadedPdfBse64] = useState({});
    const [uploadedPdfBse64Id, setUploadedPdfBse64Id] = useState({});
    const [addresses_cities1, setAddresses_cities1] = useState(null);
    const [wrongCalc, setWrongCalc] = useState(false);
    const [paymentValidation, setPaymentValidation] = useState({
        bYear: true,
        bMonth: true,
        bCC: true,
        bCVV: true,
        bId: true,
    });

    const findIndex = (arr, obj) => {
        for (var i = 0; i < arr?.length; i++) {
            if (arr[i] === obj) {
                return i;
            }
        }
        return -1;
    }
    function isNumeric(value) {
        return /^-?\d+$/.test(value);
    }

    const getTotalHmdValue = () => {
        if (selectedShipping?.paymentDate) {
            if (selectedShipping.paymentDate > 1735693200000 && selectedShipping.paymentDate < 1765255536000) {
                return 4.72;
            }
            else if (selectedShipping.paymentDate > 1765255536000 && selectedShipping.paymentDate < 1772154000000) {
                return 4;
            }
            else if (selectedShipping.paymentDate > 1772154000000) {
                return 6;
            }
        }
        return 4.68;
    }
    const getSurcharge = (ship) => {
        /*var addCharges = ship?.params?.addCharges ? Number(ship?.params?.addCharges) : 0; 
        var repack = ship?.params?.repackCost ? Number(ship?.params?.repackCost) : 0;
        var scan = getRescanCost(ship?.params?.rescanCost)
        var addFee = ship?.params?.fixedFee ? number(ship?.params?.fixedFee) : 0;*/
        var total = ship?.params?.finalAmount ? Number(ship.params.finalAmount) : 0;
        //var excRate = Number(exchangeRate.rates.ILS) / Number(exchangeRate.rates.USD);
        if (!ship.params.costSurcharge) {
            if (total <= 100)
                return 0;
            else if (total > 100 && total < 500)
                return 6;
            else if (total >= 500 && total < 1000)
                return 20;
            return 25;
        } else
            return ship.params.costSurcharge;
    }
    var getTotal = function () {
        var wt = Number(selectedShipping.params?.userPaymentData?.weight);
        var h = Number(selectedShipping.params?.userPaymentData?.height);
        var l = Number(selectedShipping.params?.userPaymentData ? selectedShipping.params?.userPaymentData["length"] : 0);
        var w = Number(selectedShipping.params?.userPaymentData?.width);

        var chargWt = Number(h) * Number(l) * Number(w) * chWtMultiplier;
        /*console.log("selectedShipping: " + JSON.stringify(selectedShipping));
        console.log("value: " + JSON.stringify(value));
        console.log("chargWt: " + chargWt);*/

        var twt = Number(chargWt > wt ? chargWt : wt);
        var ins = value.isInsurence ? Number(value.insurence) : 0;
        var hmD = value.homeDelivary ? (selectedShipping.params?.PrePaymentHomeDelivary ? Number(selectedShipping.params?.PrePaymentHomeDelivary) : 6) : 0;
        //var hmD = selectedShipping.params?.PrePaymentHomeDelivary ? Number(selectedShipping.params?.PrePaymentHomeDelivary) : (value.homeDelivary ? 6 : 0);
        if (twt > 4) hmD = selectedShipping.params?.PrePaymentHomeDelivary ? Number(selectedShipping.params?.PrePaymentHomeDelivary) : 0;
        /*console.log("total: " + value.totalInvoice);
        console.log("ins: " + ins);
        console.log("hmD: " + hmD);*/
        return Number(Number(value.totalInvoice ? value.totalInvoice : 0) + ins + (hmD)).toFixed(2);
    }
    var getTotalNIS = function () {
        var total = getTotal();
        var mul = 3.25;
        if (exchangeRate.rates) {
            mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
        }
        //return num;
        return Number(total * mul).toFixed(2)
    }
    const getSelectedShippingwithValue = (selectedShipping, value) => {
        var s = JSON.parse(JSON.stringify(selectedShipping));
        try {
            s.params.transportVal = value.transportVal ? value.transportVal : null;
            s.params.customsCharge = selectedShipping.params.customsCharge ? selectedShipping.params.customsCharge : (value.customsCharge ? value.customsCharge : null);
            s.params.costSurcharge = value.costSurcharge ? value.costSurcharge : null;
            s.params.vat = value.vat ? value.vat : null;
            s.params.isInsurence = value.isInsurence ? value.isInsurence : null;
            s.params.insurence = value.insurence ? value.insurence : null;
            s.params.couponText = value.couponText ? value.couponText : null;
            s.params.couponDeduction = value.cD ? value.cD : null;
            s.params.storageCost = value.storageCost ? value.storageCost : null;
            //s.params.repackCost = value.repackCost;
            s.params.repackCost = value.rCost ? value.rCost : null;
            //s.params.rescanCost = value.rescanCost;
            s.params.rescanCost = value.rescanCostVal ? value.rescanCostVal : null;
            s.params.consolidationCharges = value.consolidationCharges ? value.consolidationCharges : null;
            s.params.purchaseTax = value.purchaseTax ? value.purchaseTax : null;
            s.params.homeDelivary = value.homeDelivary ? value.homeDelivary : null;
            s.params.selfClearance = value.selfClearance ? value.selfClearance : null;
            s.originalPaymentData = "new";
            s.paymentDate = new Date().getTime();
            s.params.fixedFee = value.fixedFee ? value.fixedFee : null;
            s.params.returnToShipper = value.returnToShipper ? value.returnToShipper : null;
            s.params.finalAmount = getTotal();
            s.params.finalAmount_nis = getTotalNIS();
        } catch (e) {
            console.log(e);
        }
        

        return s;
    }
    const getRescanCost = (data) => {
        var total = 0;
        Object.keys(data).map(key => { total += ((key != undefined && key != "undefined") ? Number(data[key]) : 0) })
        return total;
    }
    const getTotalHmdCond = () => {
        
        var wt = Number(selectedShipping.params?.userPaymentData?.weight);
        var h = Number(selectedShipping.params?.userPaymentData?.height);
        var l = Number(selectedShipping.params?.userPaymentData ? selectedShipping.params?.userPaymentData["length"]:0);
        var w = Number(selectedShipping.params?.userPaymentData?.width);

        var chargWt = Number(h) * Number(l) * Number(w) * chWtMultiplier;

        var twt = Number(chargWt > wt ? chargWt : wt);
        if (selectedShipping.params?.PrePaymentHomeDelivary)
            return true;
        if (twt > 4) return false;
        return true;
    }

    const getStatusById = (id) => {
        for (var i = 0; i < selectedShipping?.params?.statusLog?.length; i++) {
            if (selectedShipping?.params?.statusLog[i].id == id) {
                return selectedShipping?.params?.statusLog[i].DATE;
            }
        }
        return false;
    }

    const getDateFormat = (e) => {
        var date = new Date(e);
        var dat = ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()));
        var month = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)));
        var date_formated = dat + '/' + month + '/' + date.getFullYear().toString().slice(-2) + "  " + date.getHours() + ":" + (date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes());
        return date_formated
    }
    const [bIsra, setBIsra] = useState(false);
    const [isPreviewPdf, setIsPreviewPdf] = useState(false);
    const [personalsList, setpersonalsList] = useState(personals);
    const [isBusiness, setIsBusiness] = useState(false);
    const [isFileUploaded, setIsFileUploaded] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const onDropFiles = useCallback(acceptedFiles => {


    }, [])

    const getTotalInvoiceVal = function () {
        var totalCost = value?.totalCost;

        return totalCost ? totalCost : 0;
    }
    const areValidDimentions = function () {
        if ((Number(selectedShipping?.params?.userPaymentData.height) > 110 ||
            Number(selectedShipping?.params?.userPaymentData["length"]) > 110 ||
            Number(selectedShipping?.params?.userPaymentData.width) > 110)) {
            return true;
        }
        return false;
    }
    const isValidTotalCost = function () {
        var totalCost = value.totalCost;
        if (value.selectedCurrency == 2) {
            //totalCost = totalCost * 1.03;
        }
        if (getConvertedCostByCurToUsd_UI(value.selectedCurrency, totalCost) > 2500) {
            return true;
        }/**/
        return false;
    }
    const checkFiles = function () {
        if (uploadedOrgFiles?.length >= selectedShipping?.trackListOfConsolidation?.length && selectedShipping?.consolidationStatus == 3) {
           // dispatch(snackbarToggle({ type: 'error', message: `All files are uploaded.` }));
            return true;
        }
        return false;
    }

    const checkWeight99 = () => {
        var chargWt = Number(selectedShipping?.params?.userPaymentData.height) * Number(selectedShipping?.params?.userPaymentData["length"]) * Number(selectedShipping?.params?.userPaymentData.width) * chWtMultiplier;
        if (chargWt < Number(selectedShipping?.params?.userPaymentData.weight))
            chargWt = Number(selectedShipping?.params?.userPaymentData.weight);
        if (chargWt > 300)
            return true;
        if (Number(selectedShipping?.params?.userPaymentData.height) > 110 ||
            Number(selectedShipping?.params?.userPaymentData["length"]) > 110 ||
            Number(selectedShipping?.params?.userPaymentData.width) > 110)
            return true;
        return false;
    }
    const checkWeight = function () {
        var chargWt = Number(selectedShipping?.params?.userPaymentData.height) * Number(selectedShipping?.params?.userPaymentData["length"]) * Number(selectedShipping?.params?.userPaymentData.width) * chWtMultiplier;
        var totalCost = value.totalCost;
        if (value.totalCost > 250) {
            value.homeDelivary = true;
            return true;
        }
        if (Number(selectedShipping?.params?.userPaymentData.weight) > 4)
            return true;
        if (Number(selectedShipping?.params?.userPaymentData.width) > 40 ||
            Number(selectedShipping?.params?.userPaymentData["length"]) > 40 ||
            Number(selectedShipping?.params?.userPaymentData.height) > 40)
            return true;
        return false;
    }
    const onDrop = useCallback(acceptedFiles => {

        setIsFileUploaded(false)
        var formData = new FormData();
        var bUpload = true;
        acceptedFiles.forEach((file) => {

            var fileSize = Math.round((file.size / 1024));

            if (fileSize <= 2 * 1024) {
                // alert("Uploaded");
            } else {

                // return;
                bUpload = false;
            }

            if (bUpload) {
                formData.append("file", file, file.name);
                setUploadedPdfFileName(file.name)
                var url = URL.createObjectURL(file);
                setUploadedPdf(url)
                const reader = new FileReader()

                reader.onabort = () => {
                    dispatch(snackbarToggle({ type: 'error', message: `Not a proper file` }));
                    return;
                }
                reader.onerror = () => {
                    dispatch(snackbarToggle({ type: 'error', message: `Not a proper file` }));
                    return;
                }
                reader.onload = () => {
                    // Do whatever you want with the file contents
                    const binaryStr = reader.result

                }
                reader.readAsArrayBuffer(file)
            }
        })

        if (bUpload) {

            formData.append("shippingReqId", parseInt(selectedShipping?.id));
            formData.append("reportProgress", true);
            formData.append("sessionId", userInfo.session);
            shipping_upload(formData, function (response) {
                //console.log(response)
                if (response) {
                    var data = response?.data;
                    if (data?.paramsNew) {
                        data.params = JSON.parse(data.paramsNew);
                        dispatch(setSelectedShipping(data));
                    }
                }
                if (response?.misc?.CODE == 2) {
                    dispatch(snackbarToggle({ type: 'error', message: "Upload Proper file" }));
                    setIsPreviewPdf(false)
                    setUploadedPdfFileName("")
                    setUploadedPdf(null)
                    setIsFileUploaded(true)
                } else {
                    setIsFileUploaded(true)
                    setUploadedOrgFiles(response?.data?.params?.userData?.reciept_org_names ? response?.data?.params?.userData?.reciept_org_names?.split(",") : [])
                    getBase64Reciepts()
                }

            });
        } else {
            setIsFileUploaded(true)
            dispatch(snackbarToggle({ type: 'error', message: `ניתן להעלות קבצים מסוג JPEG, PNG, BMP, PDF עד גודל 2MB` }));
        }


    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: {
            'image/png': ['.png'],
            'image/jpeg': ['.jpeg'],
            'image/bmp': ['.bmp'],
            'application/pdf': ['.pdf']

        }, onDrop
    })
    const onDropAgain = useCallback(acceptedFiles => {

        setIsFileUploaded(false)
        var formData = new FormData();
        var bUpload = true;
        acceptedFiles.forEach((file) => {

            var fileSize = Math.round((file.size / 1024));

            if (fileSize <= 2 * 1024) {
                // alert("Uploaded");
            } else {

                // return;
                bUpload = false;
            }

            if (bUpload) {
                formData.append("file", file, file.name);
                setUploadedPdfFileName(file.name)
                var url = URL.createObjectURL(file);
                setUploadedPdf(url)
                const reader = new FileReader()

                reader.onabort = () => {
                    dispatch(snackbarToggle({ type: 'error', message: `Not a proper file` }));
                    return;
                }
                reader.onerror = () => {
                    dispatch(snackbarToggle({ type: 'error', message: `Not a proper file` }));
                    return;
                }
                reader.onload = () => {
                    // Do whatever you want with the file contents
                    const binaryStr = reader.result

                }
                reader.readAsArrayBuffer(file)
            }
        })

        if (bUpload) {

            formData.append("shippingReqId", parseInt(selectedShipping?.id));
            formData.append("reportProgress", true);
            formData.append("sessionId", userInfo.session);
            shipping_upload_again(formData, function (response) {
                //console.log(response)

                if (response?.misc?.CODE == 2) {
                    dispatch(snackbarToggle({ type: 'error', message: "Upload Proper file" }));
                    setIsPreviewPdf(false)
                    setUploadedPdfFileName("")
                    setUploadedPdf(null)
                    setIsFileUploaded(true)
                } else {
                    setIsFileUploaded(true)
                    setUploadedOrgFiles(response?.data?.params?.userData?.reciept_org_names ? response?.data?.params?.userData?.reciept_org_names?.split(",") : [])
                    getBase64Reciepts()
                }
            });
        } else {
            setIsFileUploaded(true)
            dispatch(snackbarToggle({ type: 'error', message: `ניתן להעלות קבצים מסוג JPEG, PNG, BMP, PDF עד גודל 2MB` }));
        }


    }, [])
    const { getRootPropsAgain, getInputPropsAgain, isDragActiveAgain } = useDropzone({
        accept: {
            'image/png': ['.png'],
            'image/jpeg': ['.jpeg'],
            'image/bmp': ['.bmp'],
            'application/pdf': ['.pdf']

        }, onDropAgain
    })

    const copyToClipboard = (text) => {
        copyToClipboard1(text, function (data) {
            dispatch(snackbarToggle({ type: 'success', message: data }));

            window.setTimeout(function () { dispatch(snackbarToggle(false)); }, 2000);
        })
    }

    const getDimensions = () => {
        return selectedShipping.params?.userPaymentData ? (selectedShipping.params?.userPaymentData?.height + "x" + selectedShipping.params?.userPaymentData["length"] + "x" + selectedShipping.params?.userPaymentData?.width) : "0x0x0"
    }
    const getChWeight = () => {
        var wt = Number(selectedShipping.params?.userPaymentData?.weight);
        var h = Number(selectedShipping.params?.userPaymentData?.height);
        var l = Number(selectedShipping.params?.userPaymentData ? selectedShipping.params?.userPaymentData["length"] : 0);
        var w = Number(selectedShipping.params?.userPaymentData?.width);

        var chargWt = Number(h) * Number(l) * Number(w) * chWtMultiplier;

        return `${Number(chargWt > wt ? chargWt : wt).toFixed(2)} KG`;
    }
    const keyPressed = (e) => {
        if (e.keyCode === 13) {
            if (!value.totalCost) {
                dispatch(snackbarToggle({ type: 'error', message: `Please Enter Total Cost.` }));
                return
            }

            if (!value.category) {
                dispatch(snackbarToggle({ type: 'error', message: `Please Select Category.` }));
                return
            }
            if (!value.subcategory) {
                dispatch(snackbarToggle({ type: 'error', message: `Please Select Subcategory.` }));
                return
            }
            if (!value.isTnc) {
                dispatch(snackbarToggle({ type: 'error', message: `Please accept declaration.` }));
                return
            }
            calculate(value.subcategory - 1, value.couponText, couponValue);

            if (value.certificateId == 1) {
            } else {

                setValue(prev => ({ ...prev, totalInvoice: value.totalInvoice - value.fixedFee }))
                setValue(prev => ({ ...prev, fixedFee: 0 }))
            }
            setIsPreviewPdf(false)
            setActiveScreen(screens[2].screen)
        }
    }
    const handleUserData = () => {


        var u = JSON.parse(JSON.stringify(userInfo.user))
        var pickupPoint = {};
        /*var pickupPointPer = {
            Street: u.setting.register_addressLine_1,
            House: u.setting.register_addressLine_2,
            City: u.setting.register_city,
            ncode: u.setting.register_postal
        };*/
        if (value.homeDelivary) {
            pickupPoint = {
                City: value.cityNum,
                Name: value.addName,
                Phone: value.addPhone,
                Street: value.streetNum,
                House: value.buildingNum,
                ncode: value.ncodeNum,
                comment: value.comment,
            }
        } else {
            if (!pickupPoint) {
                pickupPoint = {}
            }
            pickupPoint = {
                City: cities.find(u => u.id === value.cityId)?.name,
                Street: streets.find(u => u.id === value.streetId)?.name,
                House: buildings.find(u => u.id === value.buildingId)?.name,
                ncode: streets.find(u => u.id === value.streetId)?.ncode,
            }
        }
        var d = {
            "deliveryMethod": "1",
            "deliveryInstruction": "del inst",
            "cost": value.totalCost,
            "cur": value.selectedCurrency,
            "opcode": "setUserData",
            "sessionId": userInfo.session,
            "cargoType": "1",
            "pickupPoint": pickupPoint,
            "shippingReqId": selectedShipping?.id
        }
        setUserData(userInfo.session, d, function () {

        });
    }
    const updateValue = (data) => {
        // probable future use
    }
    const [gettingUpdatedValues, setGettingUpdatedValues] = useState(false);
    
    const checkForServiceAndOnHold = (sh, callback) => {
        setGettingUpdatedValues(true);
        //dispatch(setIsShippingLoading(true));
        getShippingRequest(userInfo.session, sh.hawb, function (data) {
            data.params = JSON.parse(data.paramsNew);
            var suc = false;
            if ((data.repackStatus == 0 || data.repackStatus == 104 || data.repackStatus == 105 || data.repackStatus == null) &&
                (data.rescanStatus == 0 || data.rescanStatus == null || data.rescanStatus == 104 || data.rescanStatus == 105) &&
                ((!data.consolidationStatus || data.consolidationStatus == 3 || data.consolidationStatus == 105) &&
                    (data.shippingStatus <= 2 || data.shippingStatus == 104 || data.shippingStatus == 202))
                && data.shippingStatus != 201 && data.shippingStatus != 203) {
                suc = true;
            } else {
                suc = false;
            }
            if (suc && sh.params.userPaymentData.height == data.params.userPaymentData.height &&
                sh.params.userPaymentData.weight == data.params.userPaymentData.weight &&
                sh.params.userPaymentData.width == data.params.userPaymentData.width &&
                sh.params.userPaymentData["length"] == data.params.userPaymentData["length"] &&
                sh.params.calculatedBasePrice == data.params.calculatedBasePrice) {
                suc = true;
            } else {
                suc = false;
            }
            if (suc) {
                dispatch(setSelectedShipping(data));
                var cat = value.subcategory ? value.subcategory - 1 : 0;
                var coupon = value.couponText ? value.couponText : "";
                calculateWithData(data, cat, coupon, couponValue);
                setGettingUpdatedValues(false);
                callback(true)
            }
            else {
                tokenFlag = value.payByToken;
                tempCityId = value.cityId;
                tempStreetId = value.streetId;
                tempBuildingId = value.buildingId;
                dispatch(setSelectedShipping(data));
                var cat = value.subcategory ? value.subcategory - 1 : 0;
                var coupon = value.couponText ? value.couponText : "";
                calculateWithData(data, cat, coupon, couponValue);
                updateValue(data);
                setGettingUpdatedValues(false);
                callback(false)
            }
        })
    }
    const saveProfileData = (screen = '') => {

        var u = JSON.parse(JSON.stringify(userInfo.user))
        u.sessionId = userInfo.session;
        u.setting.profileId = value.profileId;
        //console.log(u)
        saveProfile(u, function (res) {
            //alert(res.message)
            ping(userInfo.session, function (response) {
                if (response.misc.CODE === 1) {
                    setCookie("SESSION_ID", response.session, 30);
                    dispatch(getSession(response))
                } else {
                    //
                }
            })
        });
    }
    const handleScreenData = (screen = '') => {
        if (screen === screens[0].screen) {
            // data handle for Registeration
        } else if (screen === screens[1].screen) {
            // data handle for Password            
        } else if (screen === screens[2].screen) {
            //register_user();
            // data handle for User activation 
        }
        screen && setActiveScreen(screen)
    }


    //console.log('data', value);
    const [tabValue, setTabValue] = useState(1);
    function removeEmpty(obj) {
        return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
    }

    const shipping_pay = () => {
        checkForServiceAndOnHold(selectedShipping, function (state) {
            if (state) {
                if (!userInfo.user.setting?.profileId) {
                    saveProfileData();
                }
                var mul = 3.25;
                if (exchangeRate.rates) {
                    mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
                }
                if (!mul) {
                    mul = 3.25;
                }
                var tVal = value.transportVal;
                /*if (selectedShipping?.params?.calculatedBasePrice) {
                    tVal = selectedShipping?.params?.calculatedBasePrice
                }*/
                var returnToShipper = Number(value.returnToShipper).toFixed(2);
                var returnToShipper_nis = Number(Number(value.returnToShipper) * mul).toFixed(2);
                var amount_nis = Number(getTotal() * mul).toFixed(2);
                var invoiceValue_nis = Number(value.totalCost * mul).toFixed(2);
                var storageCost_nis = Number(value.storageCost * mul).toFixed(2);
                var costSurcharge_nis = Number(value.costSurcharge * mul).toFixed(2);
                var homeDelivary_nis = Number(selectedShipping.params?.PrePaymentHomeDelivary ? Number(selectedShipping.params?.PrePaymentHomeDelivary) * mul : (value.homeDelivary ? (6 * mul) : 0)).toFixed(2);
                var transportVal_nis = Number(tVal * mul).toFixed(2);
                var orgTotalCost_nis = Number(value.orgTotalCost * mul).toFixed(2);
                var selfClearance_nis = Number(value.selfClearance * mul).toFixed(2);
                var securityFee_nis = Number(value.securityFee * mul).toFixed(2);
                var totalInvoice_nis = Number(value.totalInvoice * mul).toFixed(2);
                var repackCost_nis = Number(value.repackCost * mul).toFixed(2);
                var couponDeduction_nis = Number(value.cD * mul).toFixed(2);
                var customsCharge_nis = Number(value.customsCharge * mul).toFixed(2);
                var vat_nis = Number(value.vat * mul).toFixed(2);
                var cif_nis = Number(value.cif * mul).toFixed(2);
                var purchaseTax_nis = Number(value.purchaseTax * mul).toFixed(2);
                var aCUsed_nis = Number(value.aCUsed * mul).toFixed(2);
                var addCharges_nis = Number((value.addCharges - value.aCUsed) * mul).toFixed(2);
                var insurence_nis = Number(value.insurence * mul).toFixed(2);
                var fixedFee_nis = Number(value.fixedFee * mul).toFixed(2);
                totalInvoice_nis = Number(transportVal_nis)
                    + Number(purchaseTax_nis)
                    + Number(customsCharge_nis)
                    + Number(vat_nis)
                    + Number(addCharges_nis)
                    + Number(fixedFee_nis)
                    + Number(storageCost_nis)
                    + Number(aCUsed_nis)
                    + Number(returnToShipper_nis);
                addCharges_nis += Number(aCUsed_nis);
                var wt = Number(selectedShipping.params?.userPaymentData?.weight);
                var h = Number(selectedShipping.params?.userPaymentData?.height);
                var l = Number(selectedShipping.params?.userPaymentData ? selectedShipping.params?.userPaymentData["length"] : 0);
                var w = Number(selectedShipping.params?.userPaymentData?.width);

                var chargWt = Number(h) * Number(l) * Number(w) * chWtMultiplier;

                var twt = Number(chargWt > wt ? chargWt : wt);
                var hmD = homeDelivary_nis ? Number(homeDelivary_nis) : 0;
                hmD = Number(Number(hmD).toFixed(2));
                if (twt > 4) hmD = selectedShipping.params?.PrePaymentHomeDelivary ? Number(selectedShipping.params?.PrePaymentHomeDelivary) : 0;

                totalInvoice_nis += Number(insurence_nis) + Number(hmD.toFixed(2));

                var data1 = {
                    "storageCost": value.storageCost,
                    "storageCost_nis": storageCost_nis,
                    "part45": value.part45,
                    "store": value.store,
                    "sessionId": userInfo.session,
                    "currency": value.selectedCurrency,
                    // "invoiceOriginal": value.invoiceOriginal,
                    "invoiceOriginal": getConvertedCostByCurToUsd(value.selectedCurrency, value.totalCost),
                    "expdate": "" + cc_months.find(u => u.id === value.selectedMonth)?.name + "" + cc_years.find(u => u.id === value.selectedYear)?.name,
                    "myid": value.myid,
                    "mycvv": value.mycvv,
                    "cc_name": value.cc_name,
                    "ccno": value.ccno,
                    "returnToShipper": returnToShipper,
                    "returnToShipper_nis": returnToShipper_nis,
                    "amount": getTotal(),
                    "aCUsed": value.aCUsed,
                    "aCUsed_nis": aCUsed_nis,
                    "amount_nis": amount_nis,
                    "couponText": value.couponText,
                    "exchange_rate": mul,
                    "invoiceValue": value.totalCost,
                    "invoiceValue_nis": invoiceValue_nis,
                    "costSurcharge": value.costSurcharge,
                    "costSurcharge_nis": costSurcharge_nis,
                    "isInsurence": value.isInsurence,
                    "selfClearance": value.selfClearance,
                    "selfClearance_nis": selfClearance_nis,
                    "securityFee": value.securityFee,
                    "securityFee_nis": securityFee_nis,
                    "homeDelivary": value.homeDelivary,
                    "homeDelivary_nis": Number(selectedShipping.params?.homeDelivary_acc ? Number(selectedShipping.params?.homeDelivary_acc) * mul : (value.homeDelivary ? (6 * mul) : 0)).toFixed(2),
                    "transportVal": tVal,
                    "transportVal_nis": Number(tVal * mul).toFixed(2),
                    "orgTotalCost": value.orgTotalCost,
                    "orgTotalCost_nis": Number(value.orgTotalCost * mul).toFixed(2),
                    "totalInvoice": value.totalInvoice,
                    "totalInvoice_nis": totalInvoice_nis,
                    "repackCost": value.repackCost,
                    "repackCost_nis": Number(value.repackCost * mul).toFixed(2),
                    "couponDeduction": value.cD,
                    "couponDeduction_nis": Number(value.cD * mul).toFixed(2),
                    "customsCharge": value.customsCharge,
                    "customsCharge_nis": Number(value.customsCharge * mul).toFixed(2),
                    "vat": value.vat,
                    "vat_nis": Number(value.vat * mul).toFixed(2),
                    "cif": value.cif,
                    "cif_nis": Number(value.cif * mul).toFixed(2),
                    "cctype": value.cctype,
                    "purchaseTax": value.purchaseTax,
                    "purchaseTax_nis": Number(value.purchaseTax * mul).toFixed(2),
                    "addCharges_nis": Number(value.addCharges * mul).toFixed(2),
                    "addCharges": Number(value.addCharges).toFixed(2),
                    "insurence": value.insurence,
                    "insurence_nis": Number(value.insurence * mul).toFixed(2),
                    "majorCategory": categories.find(u => u.id === value.category)?.name || "-",
                    "minorCategory": subcategories.find(u => u.id === value.subcategory)?.name || "-",
                    "cred_type": "1",
                    "type": "TRANZILA",
                    "opcode": "shippingDelivaryRequestPay",
                    "pWt": value.pWt,
                    "wS": value.wS,
                    "fixedFee": value.fixedFee,
                    "fixedFee_nis": Number(value.fixedFee * mul).toFixed(2),
                    "cScharge": value.cS,
                    "curMul": value.curMul,
                    "shippingReqId": selectedShipping?.id,
                    "rememberPayment": value.rememberPayment,
                    "consolidationCharges": value.consolidationCharges,
                };

                data1 = removeEmpty(data1);

                data1.len = value.len;
                data1.wid = value.wid;
                data1.hei = value.hei;
                data1.wgt = value.wgt;
                data1.constWt = value.constWt;

                if (!data1.expdate || !data1.myid || !data1.mycvv || !data1.ccno || !data1.amount || !data1.shippingReqId) {
                    dispatch(snackbarToggle({ type: 'error', message: `Please enter all required fields` }));
                    return;
                }
                setIsFileUploaded(false)
                shippingDelivaryRequestPay(userInfo.session, data1, function (response) {
                    setIsFileUploaded(true)
                    if (response.misc.CODE === 1) {
                        dispatch(snackbarToggle({ type: 'success', message: `התשלום בוצע בהצלחה` }));
                        // setIsPersonal(false)
                        get_shipping_list_count();
                        setActiveScreen(8);
                    } else {
                        if (response.message === "The payment is invalid please restart payment.") {
                            //setIsPersonal(false);
                            window.location.reload();
                        } else
                            dispatch(snackbarToggle({ type: 'error', message: response.message }));
                    }
                    //setActiveScreen(6)
                })
            }
        });
        

    }
    const shipping_pay_token = (event, newValue) => {
        /*checkForServiceAndOnHold(selectedShipping, function (state) {
            if (state) {
            }
        });*/
        checkForServiceAndOnHold(selectedShipping, function (state) {
            if (state) {
                if (!userInfo.user.setting?.profileId) {
                    saveProfileData();
                }
                var mul = 3.25;
                if (exchangeRate.rates) {
                    mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
                }
                if (!mul) {
                    mul = 3.25;
                }
                var tVal = value.transportVal;

                var returnToShipper = Number(value.returnToShipper).toFixed(2);
                var returnToShipper_nis = Number(Number(value.returnToShipper) * mul).toFixed(2);
                var amount_nis = Number(getTotal() * mul).toFixed(2);
                var storageCost_nis = Number(value.storageCost * mul).toFixed(2);
                var invoiceValue_nis = Number(value.totalCost * mul).toFixed(2);
                var costSurcharge_nis = Number(value.costSurcharge * mul).toFixed(2);
                var homeDelivary_nis = Number(selectedShipping.params?.homeDelivary_acc ? Number(selectedShipping.params?.homeDelivary_acc) * mul : (value.homeDelivary ? (6 * mul) : 0)).toFixed(2);
                var selfClearance_nis = Number(value.selfClearance * mul).toFixed(2);
                var transportVal_nis = Number(tVal * mul).toFixed(2);
                var orgTotalCost_nis = Number(value.orgTotalCost * mul).toFixed(2);
                var totalInvoice_nis = Number(value.totalInvoice * mul).toFixed(2);
                var securityFee_nis = Number(value.securityFee * mul).toFixed(2);
                var repackCost_nis = Number(value.repackCost * mul).toFixed(2);
                var couponDeduction_nis = Number(value.cD * mul).toFixed(2);
                var customsCharge_nis = Number(value.customsCharge * mul).toFixed(2);
                var vat_nis = Number(value.vat * mul).toFixed(2);
                var cif_nis = Number(value.cif * mul).toFixed(2);
                var purchaseTax_nis = Number(value.purchaseTax * mul).toFixed(2);
                var aCUsed_nis = Number(value.aCUsed * mul).toFixed(2);
                var addCharges_nis = Number((value.addCharges - value.aCUsed) * mul).toFixed(2);
                var insurence_nis = Number(value.insurence * mul).toFixed(2);
                var fixedFee_nis = Number(value.fixedFee * mul).toFixed(2);
                totalInvoice_nis = Number(transportVal_nis)
                    + Number(purchaseTax_nis)
                    + Number(customsCharge_nis)
                    + Number(vat_nis)
                    + Number(addCharges_nis)
                    + Number(fixedFee_nis)
                    + Number(storageCost_nis)
                    + Number(aCUsed_nis)
                    + Number(returnToShipper_nis);
                addCharges_nis += Number(aCUsed_nis);
                var wt = Number(selectedShipping.params?.userPaymentData?.weight);
                var h = Number(selectedShipping.params?.userPaymentData?.height);
                var l = Number(selectedShipping.params?.userPaymentData ? selectedShipping.params?.userPaymentData["length"] : 0);
                var w = Number(selectedShipping.params?.userPaymentData?.width);

                var chargWt = Number(h) * Number(l) * Number(w) * chWtMultiplier;

                var twt = Number(chargWt > wt ? chargWt : wt);
                var hmD = homeDelivary_nis ? Number(homeDelivary_nis) : 0;
                hmD = Number(Number(hmD).toFixed(2));
                if (twt > 4) hmD = selectedShipping.params?.PrePaymentHomeDelivary ? Number(selectedShipping.params?.PrePaymentHomeDelivary) : 0;
                totalInvoice_nis += Number(insurence_nis) + Number(hmD.toFixed(2));
                var data1 = {
                    "storageCost": value.storageCost,
                    "storageCost_nis": storageCost_nis,
                    "part45": value.part45,
                    "store": value.store,
                    "sessionId": userInfo.session,
                    "currency": value.selectedCurrency,
                    // "invoiceOriginal": value.invoiceOriginal,
                    "invoiceOriginal": getConvertedCostByCurToUsd(value.selectedCurrency, value.totalCost),
                    "opcode": "shippingDelivaryRequestPayWithToken",
                    "pWt": value.pWt,
                    "wS": value.wS,
                    "fixedFee": value.fixedFee,
                    "fixedFee_nis": Number(value.fixedFee * mul).toFixed(2),
                    "returnToShipper": returnToShipper,
                    "returnToShipper_nis": returnToShipper_nis,
                    "cScharge": value.cS,
                    "aCUsed": value.aCUsed,
                    "aCUsed_NIS": aCUsed_nis,
                    "curMul": value.curMul,
                    "shippingReqId": selectedShipping?.id,
                    "cc_name": value.cc_name,
                    "ccno": value.ccno,
                    "amount": getTotal(),
                    "amount_nis": amount_nis,
                    "couponText": value.couponText,
                    "exchange_rate": mul,
                    "invoiceValue": value.totalCost,
                    "invoiceValue_nis": invoiceValue_nis,
                    "securityFee_nis": securityFee_nis,
                    "securityFee": value.securityFee,
                    "costSurcharge": value.costSurcharge,
                    "costSurcharge_nis": costSurcharge_nis,
                    "selfClearance": value.selfClearance,
                    "selfClearance_nis": selfClearance_nis,
                    "isInsurence": value.isInsurence,
                    "homeDelivary": value.homeDelivary,
                    "homeDelivary_nis": Number(selectedShipping.params?.PrePaymentHomeDelivary ? Number(selectedShipping.params?.PrePaymentHomeDelivary) * mul : (value.homeDelivary ? (6 * mul) : 0)).toFixed(2),
                    "transportVal": tVal,
                    "transportVal_nis": transportVal_nis,
                    "repackCost": value.repackCost,
                    "repackCost_nis": repackCost_nis,
                    "orgTotalCost": value.orgTotalCost,
                    "orgTotalCost_nis": orgTotalCost_nis,
                    "totalInvoice": value.totalInvoice,
                    "totalInvoice_nis": totalInvoice_nis,
                    "couponDeduction": value.cD,
                    "couponDeduction_nis": couponDeduction_nis,
                    "customsCharge": value.customsCharge,
                    "customsCharge_nis": customsCharge_nis,
                    "vat": value.vat,
                    "vat_nis": vat_nis,
                    "cif": value.cif,
                    "cif_nis": cif_nis,
                    "cctype": value.cctype,
                    "purchaseTax": value.purchaseTax,
                    "purchaseTax_nis": purchaseTax_nis,
                    "addCharges_nis": addCharges_nis,
                    "addCharges": Number(value.addCharges).toFixed(2),
                    "insurence": value.insurence,
                    "insurence_nis": insurence_nis,
                    "majorCategory": categories.find(u => u.id === value.category)?.name || "-",
                    "minorCategory": subcategories.find(u => u.id === value.subcategory)?.name || "-",
                    "cred_type": "1",
                    "type": "TRANZILA",
                    "rememberPayment": value.rememberPayment ? true : false,
                    "consolidationCharges": value.consolidationCharges,
                };
                setIsFileUploaded(false)

                data1 = removeEmpty(data1);

                data1.len = value.len;
                data1.wid = value.wid;
                data1.hei = value.hei;
                data1.wgt = value.wgt;
                data1.constWt = value.constWt;
                shippingDelivaryRequestPayWithToken(userInfo.session, data1, function (response) {
                    setIsFileUploaded(true)
                    if (response.misc.CODE === 1) {
                        dispatch(snackbarToggle({ type: 'success', message: `התשלום בוצע בהצלחה` }));
                        // setIsPersonal(false)
                        get_shipping_list_count();
                        setActiveScreen(8);
                    } else {
                        if (response.message === "The payment is invalid please restart payment.") {
                            //setIsPersonal(false);
                            window.location.reload();
                        } else
                            dispatch(snackbarToggle({ type: 'error', message: response.message }));
                    }
                    //setActiveScreen(6)
                })
            }
        });
    }
    const [cities, setCities] = useState([]);
    const [streets, setStreets] = useState([]);
    const [addCities, setAddCities] = useState([]);
    const [addStreets, setAddStreets] = useState([]);
    const [buildings, setBuildings] = useState([]);
    const [houseNumIsNotProper, setHouseNumIsNotProper] = useState(false);
    const [zipNumIsNotProper, setZipNumIsNotProper] = useState(false);
    const [addressIsNotProper, setAddressIsNotProper] = useState(false);
    const [ncodes, setNcodes] = useState([]);
    const saveAddress = () => {
        var u = JSON.parse(JSON.stringify(userInfo.user));
        u.sessionId = userInfo.session;
        var addList = [];
        if (myAdds.length) {
            for (var i = 0; i < myAdds.length; i++) {
                var ad = JSON.parse(JSON.stringify(myAdds[i]));
                if (ad.id == value.addId) {
                    ad.city = value.cityNum;
                    ad.building = value.buildingNum;
                    ad.street = value.streetNum;
                    ad.zipCode = value.ncodeNum;
                    ad.comment = value.comment;
                    ad.addPhone = value.addPhone;
                    ad.addName = value.addName;
                }
                addList.push(ad);
            }
        } else {
            var ad = {};
            ad.id = 0;
            ad.city = value.cityNum;
            ad.building = value.buildingNum;
            ad.street = value.streetNum;
            ad.zipCode = value.ncodeNum;
            ad.comment = value.comment;
            ad.addPhone = value.addPhone;
            ad.addName = value.addName;
            addList.push(ad);
        }
        u.setting.addressList = addList;
        saveProfile(u, function (res) {
            setMyAdds(res.user.setting.addressList)
            ping(userInfo.session, function (response) {
                if (res.misc.CODE === 1) {
                    setCookie("SESSION_ID", res.session, 30);
                    dispatch(getSession(res))
                    dispatch(snackbarToggle({ type: 'success', message: `כתובת נשמרה` }));
                } else {
                    //
                }
            })
        });
    }
    const handleWarHWts = (w, len) => {

        var t = [];
        try {
            var tV = w?.params?.wtNval;
            for (var i = 0; i < len; i++) {
                if (tV[i][0] && tV[i][1]) {
                    t.push({
                        wt: Number(tV[i][0]),
                        val: Number(tV[i][1]),
                    })
                }
            }
        } catch (e) {
            console.log(e)
        }

        // setWtAndVals(t)
        return t;
    }

    const [change, setChange] = useState(false);
    const [uploadedOrgFiles, setUploadedOrgFiles] = useState([]);
    const [uploadedOrgFilesBase64, setUploadedOrgFilesBase64] = useState([]);
    const getBase64Reciepts = () => {

        getBase64RecieptList({ id: selectedShipping.id, sessionId: userInfo.session }, function (response) {
            if (response.misc.CODE === 1) {
                setUploadedOrgFilesBase64(response.data)
                if (response?.data?.length) {
                    setUploadedPdfBse64Id(response.data[0].id)
                    setUploadedPdfBse64(response.data[0])
                }
            }
        })
    }
    const [shipmentCost1, setShipmentCost1] = useState({ id: null });
    const [storageSettings, setStorageSettings] = useState({});

    function cityExists(cts, name) {
        for (var i = 0; i < cts.length; i++) {
            if (cts[i].cityName === name) {
                return true;
            }
        }
        return false;
    }
    function streetExists(cts, name) {
        for (var i = 0; i < cts.length; i++) {
            if (cts[i].streetName === name) {
                return true;
            }
        }
        return false;
    }
    function houseExists(cts, name) {
        for (var i = 0; i < cts.length; i++) {
            if (cts[i].houseList.contains(name)) {
                return true;
            }
        }
        return false;
    }
    const [additionalCostForCalc, setAdditionalCostForCalc] = useState(null);
    useEffect(() => {
        if (tempCityId || value?.cityId || value?.buildingId || value?.streetId) {
            return;
        }
        var curCityId = value?.cityId ? value?.cityId : null;
        var curBuildingId = value?.buildingId ? value?.buildingId : null;
        var curNcodeId = value?.ncodeId ? value?.ncodeId : null;
        var curStreetId = value?.streetId ? value?.streetId : null;
        var curComment = value?.comment ? value?.comment : null;
        var curStreetNum = value?.streetNum ? value?.streetNum : null;
        var curCityNum = value?.cityNum ? value?.cityNum : null;
        
        getAdditionalCostForCalc(function (data) {
            if (userInfo.user.isComm)
                data.data.cost75 = 0;
            setAdditionalCostForCalc(data.data);
        });
        getStorageSettings(function (data) {
            setStorageSettings(data);
        });
        getShipmentCost(function (resp) {
            if (resp?.data)
                setShipmentCost1(resp?.data)
        });

        if (selectedShipping?.shippingStatus > 2 && selectedShipping?.shippingStatus != 202) {
            setActiveScreen(9)
        }
        setUploadedOrgFiles(selectedShipping?.params?.userData?.reciept_org_names ? selectedShipping?.params?.userData?.reciept_org_names?.split(",") : [])
        //console.log(selectedShipping)
        getBase64Reciepts()
        listWarehouse(function (data) {
            var ws = JSON.parse(JSON.stringify(data.data))
            var t = [];
            ws?.map((w, index) => {
                if (w.params?.active || w.name === 'טורקיה' || w.name === "Test") {
                    try {
                        w.wtNval = handleWarHWts(w, w.params?.wtNval.length);
                    } catch (e) {
                        console.log(e)
                    }
                    t.push(w);
                }
            })
            setWareHouses(t);
            
            fetch(addresses_cities_csv)
                .then(response => response.text())
                .then(responseText => {
                    var lines = responseText.split("\n");
                    var cities = [];
                    var cityStreet = {};
                    for (var i = 1; i < lines?.length; i++) {
                        var cs = lines[i]?.split(",");
                        try {
                            var city = cs[0]?.replaceAll("\r", "").replace("\"\"", "\"");
                            var street = cs[1]?.replaceAll("\r", "").replace("\"\"", "\"");
                            if (city && street) {
                                if (city[0] === "\"") {
                                    city = city.substring(1, city.length - 1);
                                }
                                if (street[0] === "\"") {
                                    street = street.substring(1, street.length - 1);
                                }
                                city = city.trim();
                                street = street.trim();
                                if (!cities.includes(city)) {
                                    cities.push(city.trim());
                                    cityStreet[city] = [street];
                                } else {
                                    cityStreet[city].push(street.trim());
                                }
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    var cts = [...new Set(cities)];
                    var cts1 = [];
                    for (var j = 0; j < cts.length; j++) {
                        cts1.push({ id: j, name: cts[j], label: cts[j] });
                    }
                    setAddCities(cts1)
                    setAddresses_cities1(cityStreet);
                    var strts = cityStreet["" + cts[0]];
                    var sts = [];
                    for (var i2 = 0; i2 < strts.length; i2++) {
                        sts.push({ id: i2, name: strts[i2], label: strts[i2] })
                    }
                    setAddStreets(sts);
                });
            for (var i = 0; i < t.length; i++) {
                if (t[i].id == selectedShipping.warehouseId) {
                    if (t[i]?.lmid && t[i]?.lmid == 2) {
                        getZigZagAddresses(function (data) {
                            var t = []
                            data?.map((d, index) => {
                                t.push({
                                    id: index + 1,
                                    name: d.cityName,
                                    ncodes: d.ncodes,
                                    streetList: d.streetList,
                                });
                            })
                            t.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            setCities(t);
                            var t1 = [];
                            var city = t.find(u => u.name === selectedShipping?.params?.userData.pickupPoint?.City);
                            city?.streetList?.map((d, index) => {
                                t1.push({
                                    id: index + 1,
                                    name: d.streetName,
                                    ncode: d.ncode,
                                    houseList: d.houseList
                                });
                            })
                            t1.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            setStreets(t1);

                            var street = t1.find(u => u.ncode === userInfo?.user?.setting?.pickupPoint?.ncode);
                            var t2 = [];
                            street?.houseList?.map((d, index) => {
                                t2.push({
                                    id: index + 1,
                                    name: d
                                });
                            })
                            t2.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            setBuildings(t2);

                            setValue(prev => ({
                                ...prev,
                                cityId: t.find(u => u.name === userInfo?.user?.setting?.pickupPoint?.City)?.id,
                                buildingId: t2.find(u => u.name === userInfo?.user?.setting?.pickupPoint?.House)?.id,
                                ncodeId: t1.find(u => u.ncode === userInfo?.user?.setting?.pickupPoint?.ncode)?.id,
                                streetId: t1.find(u => u.name === userInfo?.user?.setting?.pickupPoint?.Street)?.id,
                                payByToken: userInfo?.user?.setting?.TranzilaTK && (userInfo?.user?.setting?.expdate || (userInfo?.user?.setting?.expdateTK && userInfo?.user?.setting?.expdateTK !== "expdate")) ? true : false
                            }));
                        })
                    }
                    else {
                        
                        getCityStreetNcode(function (data) {
                            var t = []
                            data?.map((d, index) => {
                                t.push({
                                    id: index + 1,
                                    name: d.cityName,
                                    ncodes: d.ncodes,
                                    streetList: d.streetList,
                                });
                            })
                            setCities(t);
                            var t1 = [];
                            var city = t.find(u => u.name === selectedShipping?.params?.userData.pickupPoint?.City);
                            city?.streetList.map((d, index) => {
                                t1.push({
                                    id: index + 1,
                                    name: d.streetName,
                                    ncode: d.ncode,
                                    houseList: d.houseList
                                });
                            })
                            t1.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            setStreets(t1);

                            var street = t1.find(u => u.ncode === userInfo?.user?.setting?.pickupPoint?.ncode);
                            var t2 = [];
                            street?.houseList.map((d, index) => {
                                t2.push({
                                    id: index + 1,
                                    name: d
                                });
                            })
                            t2.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            setBuildings(t2);

                            setValue(prev => ({
                                ...prev,
                                cityId: t.find(u => u.name === userInfo?.user?.setting?.pickupPoint?.City)?.id,
                                buildingId: t2.find(u => u.name === userInfo?.user?.setting?.pickupPoint?.House)?.id,
                                ncodeId: t1.find(u => u.ncode === userInfo?.user?.setting?.pickupPoint?.ncode)?.id,
                                streetId: t1.find(u => u.name === userInfo?.user?.setting?.pickupPoint?.Street)?.id,
                                payByToken: userInfo?.user?.setting?.TranzilaTK && (userInfo?.user?.setting?.expdate || (userInfo?.user?.setting?.expdateTK && userInfo?.user?.setting?.expdateTK !== "expdate")) ? true : false
                            }));
                            if (curBuildingId)
                                setValue(prev => ({ ...prev, buildingId: curBuildingId }));
                            if (curNcodeId)
                                setValue(prev => ({ ...prev, ncodeId: curNcodeId }));
                            if (curStreetId)
                                setValue(prev => ({ ...prev, streetId: curStreetId }));
                            if (curCityId)
                                setValue(prev => ({ ...prev, cityId: curCityId }));

                        })
                    }
                }
            }

        });
        //shippingCoPoints
        var len = shippingCoPoints.length;
        var cities = []
        var streets = []
        var buildings = []
        var ncodes = []
        for (var i = 0; i < len; i++) {
            if (cities.indexOf(shippingCoPoints[i].city) === -1) {
                cities.push({
                    id: i + 1,
                    name: shippingCoPoints[i].city
                });
            }
            if (streets.indexOf(shippingCoPoints[i].street) === -1) {
                streets.push({
                    id: i + 1,
                    name: shippingCoPoints[i].street
                });
            }
            if (buildings.indexOf(shippingCoPoints[i].name) === -1) {
                buildings.push({
                    id: i + 1,
                    name: shippingCoPoints[i].name
                });
            }
            if (ncodes.indexOf(shippingCoPoints[i].n_code) === -1) {
                ncodes.push({
                    id: i + 1,
                    name: shippingCoPoints[i].n_code
                });
            }
        }
        var add = myAdds?.find(u => u.isDefault);
        //setValue(prev => ({ ...prev, orgTotalCost: value.totalCost }));
        if (add && addresses_cities1 != null) {
            if (!curStreetNum && !curStreetId && !curComment)
            setValue(prev => ({ ...prev, comment: "", addId: add?.id, addPhone: add?.addPhone, addName: add?.addName, cityNum: add?.city, streetNum: add?.street, buildingNum: add?.building, ncodeNum: add?.zipCode }))
            if (!add?.building) {
                setHouseNumIsNotProper(true);
            } else if (add?.building === "") {
                setHouseNumIsNotProper(true);
            } else if (isNumeric(add?.building)) {
                if (Number(add?.building) <= 999) {
                    setHouseNumIsNotProper(false);
                } else
                    setHouseNumIsNotProper(true);
            } else {
                setHouseNumIsNotProper(true);
            }
            var com = "";
            if (add?.comment) {
                if (curComment)
                    setValue(prev => ({ ...prev, comment: curComment }));
                else
                    setValue(prev => ({ ...prev, comment: add.comment }));
            }
            if (add?.city) {
                var cts = Object.keys(addresses_cities1);
                var cId = add?.city ? findIndex(cts, add.city.trim()) : -1;
                if (cId != -1) {
                    var cName = add?.city;
                    setValue(prev => ({ ...prev, cityId: cId }));
                    if (cName) {

                        var strts = addresses_cities1["" + cName];
                        var sts = [];
                        for (var i2 = 0; i2 < strts?.length; i2++) {
                            sts.push({ id: i2, name: strts[i2], label: strts[i2] })
                        }
                        setAddStreets(sts);
                        var sId = add?.street ? findIndex(strts, add.street.trim()) : -1;
                        if (sId != -1) {
                            var sName = add?.street;
                            setValue(prev => ({ ...prev, streetId: sId }));
                        } else {
                            //cityNum: add?.city, streetNum: add?.street
                            com = add?.street;
                            /*setValue(prev => ({ ...prev, streetNum: null }));
                            setValue(prev => ({ ...prev, streetId: null }));
                            setValue(prev => ({ ...prev, comment: add.street }));*/
                            if (curStreetNum)
                                setValue(prev => ({ ...prev, streetNum: curStreetNum }));
                            else
                                setValue(prev => ({ ...prev, streetNum: null }));
                            if (curStreetId)
                                setValue(prev => ({ ...prev, streetId: curStreetId }));
                            else
                                setValue(prev => ({ ...prev, streetId: null }));
                            if (curComment)
                                setValue(prev => ({ ...prev, comment: curComment }));
                            else
                                setValue(prev => ({ ...prev, comment: add.street }));
                        }
                    }
                } else {
                    /*setValue(prev => ({ ...prev, streetNum: null }));
                    setValue(prev => ({ ...prev, cityNum: null }));
                    setValue(prev => ({ ...prev, streetId: null }));
                    setValue(prev => ({ ...prev, cityId: null }));
                    setValue(prev => ({ ...prev, comment: add?.city + ", " + add.street }));*/
                    if (curStreetNum)
                        setValue(prev => ({ ...prev, streetNum: curStreetNum }));
                    else
                        setValue(prev => ({ ...prev, streetNum: null }));
                    if (curCityNum)
                        setValue(prev => ({ ...prev, cityNum: curCityNum }));
                    else
                        setValue(prev => ({ ...prev, cityNum: null }));
                    if (curStreetId)
                        setValue(prev => ({ ...prev, streetId: curStreetId }));
                    else
                        setValue(prev => ({ ...prev, streetId: null }));
                    if (curCityId)
                        setValue(prev => ({ ...prev, cityId: curCityId }));
                    else
                        setValue(prev => ({ ...prev, cityId: null }));
                    if (curComment)
                        setValue(prev => ({ ...prev, comment: curComment }));
                    else
                        setValue(prev => ({ ...prev, comment: add?.city + ", " + add.street }));

                }
            }
        }
        /*var curCityId = value?.cityId ? value?.cityId : null;
        var curBuildingId = value?.buildingId ? value?.buildingId : null;
        var curNcodeId = value?.ncodeId ? value?.ncodeId : null;
        var curStreetId = value?.streetId ? value?.streetId : null;
        var curComment = value?.comment ? value?.comment : null;
        var curStreetNum = value?.streetNum ? value?.streetNum : null;
        var curCityNum = value?.cityNum ? value?.cityNum : null;*/
        getExchangeRate(function (res) {
            setExchangeRate(res);
        });

        setValue(prev => ({ ...prev, payByToken: userInfo?.user?.setting?.TranzilaTK && (userInfo?.user?.setting?.expdate || (userInfo?.user?.setting?.expdateTK && userInfo?.user?.setting?.expdateTK !== "expdate")) }))
        if (tokenFlag)
            setValue(prev => ({ ...prev, tokenFlag }))
        tokenFlag = false;
        if (tempCityId) {
            /*var city = cities.find(u => u.id === tempCityId);
            city?.streetList.map((d, index) => {
                t.push({
                    id: index + 1,
                    name: d.streetName,
                    ncode: d.ncode,
                    houseList: d.houseList
                });
            })
            t.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            setStreets(t);

            var t2 = [];
            var street = streets.find(u => u.id === tempStreetId);

            street?.houseList.map((d, index) => {
                t2.push({
                    id: index + 1,
                    name: d
                });
            })
            t2.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            setBuildings(t2);*/
            setValue(prev => ({ ...prev, cityId: tempCityId }));
            setValue(prev => ({ ...prev, streetId: tempStreetId }));
            setValue(prev => ({ ...prev, buildingId: tempBuildingId }));
            tempCityId = null;
            tempStreetId = null;
            tempBuildingId = null;
        }
        if (userInfo.session) {

            getCouponList(userInfo.session, userInfo.user.token, function (response) {
                if (response.misc.CODE === 1) {
                    setCouponList(response.data)
                    if (props?.setCouponList) {
                        props?.setCouponList(response.data)
                    }
                }
            })
        }

    }, [dispatch, selectedShipping]);

    useEffect(() => {

        var add = myAdds?.find(u => u.isDefault);
        //setValue(prev => ({ ...prev, orgTotalCost: value.totalCost }));
        if (add && addresses_cities1 != null) {
            setValue(prev => ({ ...prev, comment: "", addId: add?.id, addPhone: add?.addPhone, addName: add?.addName, cityNum: add?.city, streetNum: add?.street, buildingNum: add?.building, ncodeNum: add?.zipCode }))
            if (!add?.building) {
                setHouseNumIsNotProper(true);
            } else if (add?.building === "") {
                setHouseNumIsNotProper(true);
            } else if (isNumeric(add?.building)) {
                if (Number(add?.building) <= 999) {
                    setHouseNumIsNotProper(false);
                } else
                    setHouseNumIsNotProper(true);
            } else {
                setHouseNumIsNotProper(true);
            }
            var com = "";
            if (add?.comment) {
                setValue(prev => ({ ...prev, comment: add.comment }));
            }
            if (add?.city) {
                var cts = Object.keys(addresses_cities1);
                var cId = add?.city ? findIndex(cts, add.city.trim()) : -1;
                if (cId != -1) {
                    var cName = add?.city;
                    setValue(prev => ({ ...prev, cityId: cId }));
                    if (cName) {

                        var strts = addresses_cities1["" + cName];
                        if (!strts)
                            strts = addresses_cities1[("" + cName).trim()];
                        var sts = [];
                        for (var i2 = 0; i2 < strts.length; i2++) {
                            sts.push({ id: i2, name: strts[i2], label: strts[i2] })
                        }
                        setAddStreets(sts);
                        var sId = add?.street ? findIndex(strts, add.street.trim()) : -1;
                        if (sId != -1) {
                            var sName = add?.street;
                            setValue(prev => ({ ...prev, streetId: sId }));
                        } else {
                            //cityNum: add?.city, streetNum: add?.street
                            com = add?.street;
                            setValue(prev => ({ ...prev, streetNum: null }));
                            setValue(prev => ({ ...prev, streetId: null }));
                            setValue(prev => ({ ...prev, comment: add.street }));
                        }
                    }
                } else {
                    setValue(prev => ({ ...prev, streetNum: null }));
                    setValue(prev => ({ ...prev, cityNum: null }));
                    setValue(prev => ({ ...prev, streetId: null }));
                    setValue(prev => ({ ...prev, cityId: null }));
                    setValue(prev => ({ ...prev, comment: add?.city + ", " + add.street }));

                }
            }
        }
    }, [addresses_cities1]);
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const categories = settingsRedbox.map((setting, index) => ({
        id: index + 1,
        name: setting.name
    }));
    const [myAdds, setMyAdds] = useState(userInfo.user.setting?.addressList ? (userInfo.user.setting?.addressList?.map((setting, index) => ({
        id: index + 1,
        name: setting.city + ", " + setting.street + ", " + setting.building,
        addName: setting.addName ? setting.addName : userInfo.user.firstName + " " + userInfo.user.lastName,
        addPhone: setting.addPhone ? setting.addPhone : userInfo.user.phone,
        city: setting.city,
        street: setting.street,
        building: setting.building,
        zipCode: setting.zipCode,
        isDefault: setting.isDefault,
        comment: setting.comment,
    }))) : []);
    const [subcategories, setSubcategories] = useState([]);
    const [subcategories3, setSubcategories3] = useState([]);
    const [subcategories4, setSubcategories4] = useState([]);
    const [subcategories5, setSubcategories5] = useState([]);
    const [subcategories6, setSubcategories6] = useState([]);
    const [subcategories7, setSubcategories7] = useState([]);

    const [exchangeRate, setExchangeRate] = new useState({});

    const [openInsuranceDialog, setOpenInsuranceDialog] = useState(false);
    const onHandleCancelInsuranceDialog = () => {
        setOpenInsuranceDialog(false);

    };
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const onHandleOpenModal = (add, ind) => {
        setOpenOrderModal(true);

    };
    const onHandleCancelModal = () => setOpenOrderModal(false);
    const [selectedRecieptName, setSelectedRecieptName] = useState("");
    
    const [openOrderModalDelete, setOpenOrderModalDelete] = useState(false);
    const onHandleOpenModalDelete = (name) => {
        setSelectedRecieptName(name)
        setOpenOrderModalDelete(true);

    };
    const onHandleCancelModalDelete = () => {
        setOpenOrderModalDelete(false);
        if (activeScreen === 8) {
            window.location.reload();
        }
    }
    const deleteSelectdReciept = (name) => {

        deleteReciept({ sessionId: userInfo.session, id: selectedShipping.id, name: name }, function (response) {
            if (response?.misc?.CODE === 1) {
                getBase64Reciepts()
                dispatch(setSelectedShipping(response.data));
                onHandleCancelModalDelete();
            }
        })
    }
    const progressSteps = (currentScreen = null) => (
        <>
            {selectedShipping.consolidationStatus != 3 &&<Grid container className="screen-progress-steps">
                {screens.map((val, index) =>
                    <Box key={val.screen + index} className={`progress-step ${currentScreen === val.screen && 'current'} ${currentScreen > val.screen && 'done'}`}>
                        <Box className="step-circle">
                            {val.screen}
                        </Box>
                        <Box className="step-title">
                            {val.title}
                        </Box>
                    </Box>)}
            </Grid>}
            {selectedShipping.consolidationStatus == 3 &&<Grid container className="screen-progress-steps">
                {screensMulti.map((val, index) =>
                    <Box key={val.screen + index} className={`progress-step ${currentScreen === val.screen && 'current'} ${currentScreen > val.screen && 'done'}`}>
                        <Box className="step-circle">
                            {val.screen}
                        </Box>
                        <Box className="step-title">
                            {val.title}
                        </Box>
                    </Box>)}
            </Grid>}

        </>
    );

    const screen_A = (
        <Box className="reg_popup_data">
            
            {progressSteps(1)}

            <Grid className="popup_tittle lg" >
                {selectedShipping?.consolidationStatus == 3?'העלאת חשבוניות':'העלאת חשבונית'}   
            </Grid>
            <Grid className="popup_tittle sm" >
                חבילה מספר {selectedShipping?.id}
            </Grid>

            <Grid container className="grey-box-area">
                <Grid container className="box-row">
                    <Grid className="row-Label">
                        שם החנות:
                    </Grid>
                    <Grid className="row-Value">
                        {selectedShipping?.params?.sender?.senderName}
                    </Grid>
                </Grid>
                <Grid container className="box-row">
                    <Grid className="row-Label">
                        תאור הפריט:
                    </Grid>
                    <Grid className="row-Value">
                        {selectedShipping?.shippingDesc}
                    </Grid>
                </Grid>
            </Grid>

            <Box className="dropzone-area" >
                <Grid container className="upload-content">
                    <div {...getRootProps({
                        onClick: (event) => {
                            if (checkFiles()) {
                                event.stopPropagation();
                            }
                        }
                    })} className='upload-area'>
                        <input {...getInputProps()} />
                        {
                            <Grid container className="upload-content">
                                <img className='upload' src={upload} alt='upload' />
                                {selectedShipping.consolidationStatus == 3 && uploadedOrgFiles?.length>0 && !checkFiles() && <Box className="content-line-1">
                                    ניתן להעלות מספר חשבוניות
                                </Box>}
                                {selectedShipping.consolidationStatus == 3 && uploadedOrgFiles?.length > 0 && checkFiles() && <Box className="content-line-1">
                                    החשבוניות עלו בהצלחה
                                </Box>}
                                <Box className="content-line-1" style={{ direction: "rtl", textAlign: "right" }}>
                                    {`להעלאת חשבונית הקנייה`} <a style={{ textDecoration: "underline", color: "#FF3452" }}>{`לחץ כאן`}</a> { `>>>`}
                                </Box>
                                <Box className="content-line-1" style={{ direction: "rtl" }}>
                                    <span>
                                        ניתן להעלות קבצים מסוג JPEG, PNG, BMP, PDF עד גודל 2MB
                                    </span>
                                </Box>
                            </Grid>
                        }
                    </div>
                </Grid>
                {uploadedOrgFiles?.length>0 && <Grid container item >
                    {uploadedOrgFiles.map((val, index) =>
                        <Grid container item justifyContent="flex-end">
                            <Grid container item lg={ 5} style={{ color:"#FF3452",fontWeight:"bold"}}>{val}</Grid>
                            <Grid container item lg={2} onClick={() => {
                                

                                var filePdf = uploadedOrgFilesBase64.find(u => u.name === val);
                                setUploadedPdfBse64Id(filePdf.id);
                                setIsPreviewPdf(!isPreviewPdf)
                            }} style={{ marginLeft: "5px", backgroundImage: `url(${file})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '20px' }}></Grid>
                            <Grid container item lg={2} onClick={() => {
                                

                                onHandleOpenModalDelete(val)
                            }} title={ 'Delete Invoice'} style={{ marginLeft: "15px", backgroundImage: `url(${del})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '20px' }}></Grid>

                        </Grid>)}
                        
                   </Grid>
                }
            </Box>
            {!isFileUploaded && <Loader />}
            {checkWeight99() && <Grid onClick={() => { window.open("/contactUs", "_blank") }} sx={{ textAlign: "center", cursor: "pointer", color: "red", textDecoration: "underline", mb: 1, mt: 1 }}> בקשה צור קשר עם שרות לקוחות</Grid>}
            <Grid container className='form-action grid-action'>
                <ActionButton disabled={(!uploadedOrgFiles.length || checkWeight99()) } className={'left-action-btn'} textLabel={'המשך'} onClick={() => {

                    if (!uploadedOrgFiles.length) {
                        return;
                    }
                    setActiveScreen(screens[1].screen)
                    setIsPreviewPdf(true)
                    setValue(prev => ({ ...prev, homeDelivary: checkWeight() }))
                }} />
                <ActionButton disabled={!uploadedOrgFiles.length} className={'left-action-btn'} textLabel={'תצוגה'} onClick={() => {

                    if (!uploadedOrgFiles.length) {
                        return;
                    }
                    setIsPreviewPdf(!isPreviewPdf)
                    if (uploadedOrgFilesBase64.length > 0)
                        setUploadedPdfBse64Id(uploadedOrgFilesBase64[uploadedOrgFilesBase64.length].id);
                }} />
                {<ActionButton disabled={!uploadedOrgFiles.length} className={'left-action-btn'} textLabel={'מחק'} onClick={() => {
                    setIsPreviewPdf(false)
                    setUploadedPdfFileName("")
                    setUploadedPdf(null)
                    if (uploadedOrgFiles?.length > 0) {
                        for (var i = 0; i < uploadedOrgFiles?.length; i++) {
                            deleteSelectdReciept(uploadedOrgFiles[i]);
                        }
                    }
                }} />}

            </Grid>
            {/*<Grid container className='form-action grid-action' justifyContent="center" >

                <Box className="right-action-text" sx={{ width: "100%", textAlign: "center !important"}}>
                    צריכים עזרה בהעלאת החשבונית <span className='link' onClick={() => {
                        window.open("https://redboxparcel.com/FAQS", "_blank")
                    }}>? למדריך המלא</span>
                </Box>
            </Grid>*/}
            <Box className="screen-bottom-text" style={{ direction: "rtl", fontSize:"18px" }}>
                {`שימו לב,`} <br />
            </Box>
            <Box className="screen-bottom-text" style={{ direction: "rtl", textAlign: "right", marginRight:"10px" }}>
                {`1. לפי תקנות המכס על החשבונית לכלול את הפרטים הבאים: שם המוכר, שם הקונה, תיאור המוצרים ועלותם. מומלץ להעלות כקובץ PDF`}
            </Box>
            {/*<Box className="screen-bottom-text" style={{ direction: "rtl", textAlign: "right", marginRight: "20px" }}>
                {`לפי תקנות המכס על החשבונית לכלול את סכום המוצר, תיאור המוצר ושם הספק.`} <br />
            </Box>*/}
            <Box className="screen-bottom-text" style={{ direction: "rtl", textAlign: "right", marginRight: "10px" }}>
                {`2. ייבוא לישראל אינו מותר לקטינים, מתחת לגיל 18, על פי חוקי והנחיות המכס.`}<br />
            </Box>
            <Box className="screen-bottom-text" style={{ direction: "rtl", textAlign: "right", marginRight: "20px" }}>
                { `אם הנך מתחת לגיל 18 : על מנת להימנע מעיכוב בשחרור מהמכס, העשוי לגרור עלויות נוספות`} <br/>
                { `יש להעביר אלינו למייל info@redboxparcel.com  צילום תעודת זהות של אחד ההורים`} <br/>
                <a href="/parentAproval.pdf" style={{ color: "#FF3452" }} target="_blank">{`וייפוי כח מההורה.`}</a> <br /><br /><br /><br /><br />
            </Box>
            {selectedShipping?.consolidationStatus == 3 && <Grid container justifyContent="center">
                <b> במידה והתשלום הוא על משלוח שמאחד מספר חבילות יש לצרף את כל החשבוניות <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  הרלוונטיות ולגרור אותן אחת אחר השנייה למשבצת העלאת חשבוניות</b>
            </Grid>}
            <Grid item container style={{ direction: "rtl" }}><br /><br />
            </Grid>
            <Grid style={{ height: "60vh" }}></Grid>
        </Box>);
    function getStringRule(data) {
        var arr = JSON.parse(data)
        return arr
    }
    const getCouponValue = (ct, wt, validC) => {
        if (!ct) {
            return 0;
        }
        var p1 = 0;
        if (validC) {
            couponList.map((c) => {
                if (c.couponId == ct) {
                    var mRules = getStringRule(c.multiRules);
                    mRules.map((r, i) => {
                        var w = r[0];
                        var p = r[1];
                        if (i == 0 && Number(wt) < Number(w)) {
                            p1 = p;
                        } else if (i == mRules.length - 1 && Number(wt) > Number(w)) {
                            p1 = p;
                        } else if (Number(wt) < Number(w)) {
                            p1 = mRules[i - 1][1]
                        }
                    })
                }
            })
        }
        return p1;
    }
    const getConvertedCostByCurToNIS_UI = (cur, amount) => {
        //var amount = getConvertedCostByCurToUsd_UI(cur, amount);
        if (cur == 1) { //USD
            var mul = 4.00;
            if (exchangeRate.rates) {
                mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
            }
            return amount * mul;
        }
        if (cur == 2) { // EUR
            var mul = 4.24;
            if (exchangeRate.rates) {
                mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.EUR
            }
            return amount * mul;
        }
        if (cur == 3) { // GBP
            var mul = 4.87;
            if (exchangeRate.rates) {
                mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.GBP
            }
            return amount * mul;
        }
        if (cur == 4) { // TRY
            var mul = 0.14;
            if (exchangeRate.rates) {
                mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.TRY
            }
            return amount * mul;
        }
        return Number(amount)
    }
    const getConvertedCostByCurToUsd_UI = (cur, amount) => {

        if (cur == 1) {
            return amount
        }
        if (cur == 2) {
            var eurMul = 1.03;
            if (exchangeRate.rates) {
                eurMul = exchangeRate?.rates?.USD
            }
            amount = amount * eurMul;
            return amount
        }
        if (cur == 3) {
            var poundMul = 1.28;
            if (exchangeRate.rates) {
                poundMul = exchangeRate?.rates?.USD / exchangeRate?.rates?.GBP
            }
            amount = amount * poundMul;
            return amount
        }
        if (cur == 4) {
            var turMul = 0.037;
            if (exchangeRate.rates) {
                turMul = exchangeRate?.rates?.USD / exchangeRate?.rates?.TRY
            }
            amount = amount * turMul;
            return amount
        }
        return Number(amount)
    }
    const getConvertedCostByCurToUsd = (cur, amount) => {

        if (cur == 1) {
            setValue(prev => ({ ...prev, curMul: 1 }));
        }
        if (cur == 2) {
            var eurMul = 1.03;
            if (exchangeRate.rates) {
                eurMul = exchangeRate?.rates?.USD
            }
            amount = amount * eurMul;
            setValue(prev => ({ ...prev, curMul: eurMul }));
            return amount
        }
        if (cur == 3) {
            var poundMul = 1.28;
            if (exchangeRate.rates) {
                poundMul = exchangeRate?.rates?.USD / exchangeRate?.rates?.GBP
            }
            setValue(prev => ({ ...prev, curMul: poundMul }));
            amount = amount * poundMul;
            return amount
        }
        /*if (cur == 4) {
            var turMul = 0.037;
            if (exchangeRate.rates) {
                turMul = exchangeRate?.rates?.USD / exchangeRate?.rates?.TRY
            }
            setValue(prev => ({ ...prev, curMul: turMul }));
            amount = amount * turMul;
            return amount
        }*/
        if (cur == 4) {
            var polMul = 0.25;  
            if (exchangeRate.rates) {
                polMul = exchangeRate?.rates?.USD / exchangeRate?.rates?.PLN
            }
            setValue(prev => ({ ...prev, curMul: polMul }));
            amount = amount * polMul;
            return amount
        }
        if (cur == 5) {
            var cadMul = 0.73;
            if (exchangeRate.rates) {
                cadMul = exchangeRate?.rates?.USD / exchangeRate?.rates?.CAD
            }
            setValue(prev => ({ ...prev, curMul: cadMul }));
            amount = amount * cadMul;
            return amount
        }
        /*if (amount > 250) {
            setInsurenceDisabled(true)
        } else {
            setInsurenceDisabled(false)
        }*/
        return Number(amount)
    }
    const [validCoupon, setValidCoupon] = useState(false);
    const [couponValue, setCouponValue] = useState(0);
    const [couponD, setCouponD] = useState(0);
    const checkCoupon = (cpnText) => {
        var p1 = false;
        couponList.map((c) => {
            if (ciEquals(c.couponId, cpnText)) {
                setCouponD(c);
                p1 = true

            }
        })
        var chargWt = Number(selectedShipping?.params?.userPaymentData.height) * Number(selectedShipping?.params?.userPaymentData["length"]) * Number(selectedShipping?.params?.userPaymentData.width) * chWtMultiplier;

        var wt = Number(selectedShipping?.params?.userPaymentData.weight);
        var twt = chargWt > wt ? chargWt : wt;
        
        isValidCoupon(userInfo.session, userInfo.user.token, selectedShipping.id, selectedShipping.warehouseId, cpnText, function (response) {
            //
            setValidCoupon(response)
            getCouponValue1(userInfo.session, userInfo.user.token, selectedShipping.id, selectedShipping.warehouseId, cpnText, twt, function (response) {
                //
                setCouponValue(response)
                calculate(value.subcategory - 1, cpnText, response)
            })
        })
        return p1;
    }
    function ciEquals(a, b) {
        return typeof a === 'string' && typeof b === 'string'
            ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
            : a === b;
    }

    const getDaysOver = (data) => {
        var countDate = data.create_date;
        if (countDate < 1757898061000)
            return 0;
        if (data.countDate)
            countDate = data.countDate;
        var now = new Date().getTime();
        var dif = now - countDate;
        dif /= 3600 * 24000;
        return Number(Number(dif).toFixed(0));
    }
    const getStorageCost = (data, freeDays, costPerWeek) => {
        if ("storageCharge" in data?.params) {
            return data.params?.storageCharge;
        }
       /* if (data.params?.storageCharge)
            return Number(data.params?.storageCharge)
        if (data.params?.storageCharge === "0")
            return data.params?.storageCharge*/
        var days = getDaysOver(data);
        if (days > freeDays) {
            var calc = 0;
            var payDays = days - freeDays;
            var payMul = Math.ceil(Number(payDays / 7));
            if (payMul > 0) {
                calc = payMul * costPerWeek
            }
            if (data?.params?.storageCharge)
                calc = data?.params?.storageCharge;
            return calc;
        } else {
            return null;
        }
    }
    const calculate = (index, cp, validC) => {
        return calculateWithData(selectedShipping, index, cp, validC)
    }
    const calculateWithData = (data, index, cp, validC) => {
        var couponData = null;
        if (cp.length > 0) {
            var p1 = false;
            couponList.map((c) => {
                if (ciEquals(c.couponId, cp)) {
                    couponData = c;
                    p1 = true
                }
            })
            if (!p1) {
                //dispatch(snackbarToggle({ type: 'error', message: `Coupon is not valid.` }));
                // return
            }

        }
        var line66 = false;
        var addCharges = 0;

        var chargWt = Number(data?.params?.userPaymentData.height) * Number(data?.params?.userPaymentData["length"]) * Number(data?.params?.userPaymentData.width) * chWtMultiplier;
        var wt = Number(data?.params?.userPaymentData.weight);
        var twt = chargWt > wt ? chargWt : wt;
        //var cPer = Number(getCouponValue(cp, twt, validC));
        var cPer = Number(validC);

        var ind = value.subCategory - 1;
        var additionalCharges = Number(data?.params?.additionalCharges ? data?.params?.additionalCharges : 0);
        var consolidationCharges = Number(data?.params?.consolidationCharges_acc ? data?.params?.consolidationCharges_acc : (data?.params?.consolidationCharges ? data?.params?.consolidationCharges : 0));
        var calculatedBasePrice = Number(data?.params?.calculatedBasePrice ? data?.params?.calculatedBasePrice : 0);
        var h = Number(data?.params?.userPaymentData.height);
        var l = Number(data?.params?.userPaymentData["length"]);
        var w = Number(data?.params?.userPaymentData.width);
        var totalCost = Number(value.totalCost)
        setValue(prev => ({ ...prev, invoiceOriginal: totalCost }));
        totalCost = getConvertedCostByCurToUsd(value.selectedCurrency, totalCost);

        var ind = index;
        var wh = wareHouses.find(u => u.id === data.warehouseId);
        if (!wh) {
            dispatch(snackbarToggle({ type: 'error', message: `Service not available.` }));
            setIsPersonal(false)
            return;
        }
        var wVal = weightAndVal;
        if (wh?.wtNval) {
            wVal = wh?.wtNval;
        }
        var storage = JSON.parse(JSON.stringify(storageSettings));
        storage.sh = data;
        var storageValue = getStorageCost(data, storage.storageFreeDays, storage.storageCostPerWeek);
        if (storageValue != null)
            storageValue = Number(storageValue);
        else if (data.params.totalStorageCost) {
            storageValue += data.params.totalStorageCost;
        }
        return calculateValues(h, l, w, wt, wVal, ind, subcategories3, subcategories4, subcategories5, value.isCertificate, totalCost, cPer, setValue, calculatedBasePrice, consolidationCharges, additionalCharges, shipmentCost1?.price, additionalCostForCalc, exchangeRate, userInfo.user.isComm ? 2 : 1, data?.shippingPrice ? data?.shippingPrice : 0, data.params?.repackCosts ? data.params?.repackCosts : {}, data.params?.rescanCost ? data.params?.rescanCost : {}, couponData, storage, storageValue, data.params);
    }
    const screen_b = (
        <Box className="reg_popup_data">
            {progressSteps(2)}

            <Grid className="popup_tittle lg" >
                { `הצהרת מכס`}
            </Grid>
            <Grid className="popup_tittle sm" style={{ marginBottom: "5px" }}>
                <div onClick={() => setIsPreviewPdf(!isPreviewPdf)} style={{ marginLeft: "5px", cursor: 'pointer', backgroundRepeat: "no-repeat", height: '20px', }}>{ `<<<  לחשבונית לחץ כאן`}</div>
                {/*<div>{uploadedPdfFileName}</div>
                <div onClick={() => setIsPreviewPdf(!isPreviewPdf)} style={{ marginLeft: "5px", backgroundImage: `url(${file})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '20px', }}></div>*/}
            </Grid>
            <Grid className="popup_tittle sm">
                <div>{selectedShipping.hawb} {`חבילה מס׳`}</div>
            </Grid>
            {/*<Grid item container style={{ direction: "rtl", fontWeight: "bold", fontSize:"16px", color:"#FF3452" }} justifyContent="flex-start">
                
            </Grid>*/}
            <Grid container item style={{ direction: "rtl", fontWeight: "bold" }}>
                {`הצהרה למכס על עלות המוצר:`}<br />
                { `1. ` } { `מוצרים שעלו עד 75$ - יש לרשום את ערך המוצר בלבד (לא כולל מסים והובלה מקומית)`}<br />
                { `2. `} { `מוצרים בעלות של 75$ ומעלה - יש לרשום את עלות המוצר ועלות ההובלה המקומית בחו"ל.`}<br /><br />
            </Grid>

            <Box>

                <Box container className='label-wrapper'>
                    <Box component={'span'} className='input-label'>
                        {/*{selectedShipping?.consolidationStatus == 3 ? 'עלות המוצרים (ללא מיסים והובלה בחו״ל)' :' עלות מוצר ( ללא מיסים והובלה בחו״ל)'}*/}
                        {selectedShipping?.consolidationStatus == 3 ? 'עלות המוצרים' : 'עלות מוצר'}
                        
                    </Box>
                    {/*<Box component={'span'} className='ques-icon'>
                        <img src={questionMark} alt="" />
                    </Box>*/}
                </Box>
                <Grid container className='input-wrapper' >
                    <TextField
                        className='text-field short'
                        required
                        value={value.totalCost}
                        type="number"
                        step="0.01"
                        onChange={event => {
                            //if(event.target.value!=0)
                                setValue(prev => ({ ...prev, totalCost: event.target.value }))
                        }}
                        label='הקלידו כאן'
                        islabelAnimate={false}
                        isPrefix
                        parentClassName=''
                        sx={{ width: "40%", mr: "5px", mt: "5px", minWidth: "200px" }}
                    />
                    <Grid container item style={{maxWidth: "200px"}}>
                        <SelectField
                            className='text-field1'
                            sm={5}
                            required
                            value={value.selectedCurrency}
                            onChange={event => setValue(prev => ({ ...prev, selectedCurrency: event.target.value }))}
                            label=''
                            options={currencies}
                            islabelAnimate={false}
                            isPrefix
                            parentClassName={'select-field '}
                            dir="rtl"
                            isNumeric={true}
                            sx={{ m: 0, mr: "10px", mt: "10px" }}
                        />
                    </Grid>
                </Grid>
                {(isValidTotalCost()) && <Box style={{ color: "red", textAlign: "right" }}>
                    {`.שימו לב, במקרה של אבדן או נזק, תקרת הפיצוי המקסימלי הינה 1000$`}
                </Box>
                }
                <Grid container item style={{direction:"rtl", fontWeight:"bold"}}>
                    <p style={{ marginBottom: "0", marginTop: "10px" }}>{`במידה והמטבע המצוין בחשבונית שונה מ USD או EUR אנא השתמשו `}<a style={{ color:"#FF3452"}} href="https://www.gov.il/apps/taxes/currencyGates/" target="_blank">בקישור</a></p>
                    <p style={{ marginBottom: "0", marginTop: "0px" }}>{`על מנת להמנע מהפרשי שער מול רשות המיסים.` }</p>
                </Grid>
                <br/>
                <Box container className='label-wrapper'>
                    <Box component={'span'} className='input-label'>
                        קטגוריה
                    </Box>
                    {/*<Box component={'span'} className='ques-icon'>
                        <img src={questionMark} alt="" />
                    </Box>*/}
                </Box>

                {
                    /*  <Grid container className='input-wrapper'>
                      <TextField
                          className='text-field short'
                          required
                          value={value.totalCost}
                          type="number"
                          onChange={event => setValue(prev => ({ ...prev, totalCost: event.target.value }))}
                          label='הקלידו כאן'
                          islabelAnimate={false}
                      />
                  </Grid>*/
                }

                <Grid container className='input-wrapper dir-rtl' style={{ marginTop: "10px" }}>
                    <Grid container className='input-wrapper dir-rtl' flexWrap="nowrap" style={{ margin: "5px", marginTop: "0", marginBottom: "0" }}>
                        <Grid container item sm={4} style={{ maxWidth: "33%" }}>
                            <SelectField
                                className='text-field1'
                                required
                                value={value.category}
                                onChange={event => {
                                    setValue(prev => ({ ...prev, category: event.target.value }));
                                    var t = settingsRedbox[event.target.value - 1].subCategory.category1
                                    var t2 = t.map((setting, index) => ({
                                        id: index + 1,
                                        name: setting
                                    }));
                                    setValue(prev => ({ ...prev, subcategory: null }));
                                    setSubcategories6([]);
                                    setSubcategories7([]);
                                    setSubcategories(t2);
                                    setSubcategories3(settingsRedbox[event.target.value - 1].subCategory.category3);
                                    setSubcategories4(settingsRedbox[event.target.value - 1].subCategory.category4);
                                    if (settingsRedbox[event.target.value - 1].subCategory?.category5)
                                        setSubcategories5(settingsRedbox[event.target.value - 1].subCategory.category5);
                                    else
                                        setSubcategories5([]);
                                }}
                                dir="rtl"
                                options={categories}
                                islabelAnimate={false}
                                isNumeric={true}
                                parentClassName={'select-field width-50 mar_10'}
                                sx={{ mr: "0" }}
                            />
                        </Grid>
                        <Grid container item sm={4} style={{ maxWidth: "33%" }}>
                            <SelectField
                                className='text-field1'
                                parentClassName={'select-field width-50 mar_10'}
                                dir="rtl"
                                disabled={!value.category}
                                required
                                value={value.subcategory}
                                onChange={event => {
                                    setValue(prev => ({ ...prev, subcategory: event.target.value }));
                                    //setValue(prev => ({ ...prev, orgTotalCost: value.totalCost }));

                                    if (calculate(event.target.value - 1, value.couponText, couponValue)) {
                                        setValue(prev => ({ ...prev, certificateId: 1 }))
                                        var t = settingsRedbox[value.category - 1];
                                        if (t.subCategory.category6) {
                                            setSubcategories6(t.subCategory.category6[event.target.value - 1]);
                                        }
                                        if (t.subCategory.category7) {
                                            setSubcategories7(t.subCategory.category7[event.target.value - 1]);
                                        }
                                    } else {
                                        setWrongCalc(true);
                                    }
                                }}
                                options={subcategories}
                                islabelAnimate={false}
                                isPrefix
                                isNumeric={true}
                                sx={{ mr: "0" }}
                            />
                        </Grid>
                        <Grid container item sm={4} style={{ maxWidth: "33%" }}>
                            <TextField
                                className='text-field short'
                                required
                                value={value.store}
                                type="text"
                                onChange={event => {
                                    if (event.target.value.length < 16)
                                        setValue(prev => ({ ...prev, store: event.target.value }))
                                }}
                                label='שם הספק'
                                islabelAnimate={false}
                                isPrefix
                                parentClassName=''
                                sx={{ mr: "0", mt: "5px" }}
                            />
                        </Grid>
                    </Grid>
                    {(subcategories6 && subcategories6.length != 0) && <Grid container className='input-wrapper dir-rtl' style={{ border: "1px #FF3452 solid", marginTop: "0" }}>
                        {subcategories6.map((sub6, index) => (<Grid item container style={{ margin: "10px", color: "#FF3452", fontWeight: "bold", fontSize: "16px" }}> {sub6} {(subcategories7 && subcategories7[index]) && <a href={`/${subcategories7[index]}`} target="_blank" style={{ color: "#FF3452", marginRight: "5px" }}>{`(לחץ כאן)`}</a>}</Grid>))}
                    </Grid>}
                </Grid>

                {value.category == 7 && value.fixedFee>0 &&
                    
                    <Grid>
                        <Grid container justifyContent="flex-start" style={{marginTop: "15px", direction: "rtl", fontWeight: "bold"}}>
                            { `האם ברצונך שרד-בוקס יפיקו עבורך אישור תחבורה?`}
                        </Grid>
                        <Box container className='checkboxs' sx={{ mt: 2 }} style={{ alignItems: "flex-end" }}>

                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={value.certificateId}
                                onChange={(event) => {

                                    setValue(prev => ({ ...prev, certificateId: event.target.value }));
                                    setValue(prev => ({ ...prev, isCertificate: !value.isCertificate }));
                                }}
                            >
                                {
                                    value.cirtificateList.map(qs => (
                                        <Grid><Radio color={'info'} value={qs.id} /> {qs.name}</Grid>
                                        /*<FormControlLabel style={{ fontSize: '0.8rem', maxWidth: '4vw', padding: '5px' }} control={} label={qs.name} />*/
                                    ))
                                }
                            </RadioGroup>
                        </Box>
                    </Grid>
                }

                <Box container className='checkboxs' sx={{ mt: 2 }}>
                    <FormControlLabel className="check-box" key={uuidv4()} control={< Checkbox onKeyDown={e => keyPressed(e)} checked={value?.isTnc} onChange={event => {
                        setValue(prev => ({ ...prev, isTnc: event.target.checked }));
                    }} />} label=" 1. אני מצהיר/ה בזאת כי החשבונית תקינה ותואמת לתכולת החבילה בפועל. " />
                    <p style={{direction: "rtl", marginRight: "20px"}}>{`2. במידה והחשבונית אינה תואמת לתוכן החבילה בפועל, חסרים אישורים הנדרשים ע''י רשויות החוק בישראל או החבילה תעצר על ידי המכס לבדיקה פיזית : אני מודע/ת לכך שיחולו עלויות של 65$ בגין שחרור פרטני, ובנוסף יתכנו הפרשי מס וחיובי אחסנה במסוף אותם יהיה לשלם על מנת להמשיך בשחרור החבילה מהמכס.`}</p>
                </Box>
                {(areValidDimentions()) && <Box style={{ color: "red" }}>
                    
                    { `אנא צרו קשר עם שרות לקוחות`}
                </Box>
                }
                <Box className='form-action' style={{marginBottom:"15vh"}}>
                    {/*<ActionButton disabled={wrongCalc || areValidDimentions() || gettingUpdatedValues  || !value.category || !value.subcategory || !value.totalCost || !value.isTnc} className={'submit-action small'} textLabel={'תשלום'} onClick={() => {*/}
                    <ActionButton disabled={areValidDimentions() || gettingUpdatedValues  || !value.category || !value.subcategory || !value.totalCost || !value.isTnc} className={'submit-action small'} textLabel={'תשלום'} onClick={() => {

                        if (!value.totalCost) {
                            dispatch(snackbarToggle({ type: 'error', message: `Please Enter Total Cost.` }));
                            return
                        }

                        if (!value.category) {
                            dispatch(snackbarToggle({ type: 'error', message: `Please Select Category.` }));
                            return
                        }
                        if (!value.subcategory) {
                            dispatch(snackbarToggle({ type: 'error', message: `Please Select Subcategory.` }));
                            return
                        }
                        if (!value.isTnc) {
                            dispatch(snackbarToggle({ type: 'error', message: `Please accept declaration.` }));
                            return
                        }
                        checkForServiceAndOnHold(selectedShipping, function (state) {
                            if (state) {
                                //calculate(value.subcategory - 1, value.couponText, couponValue);

                                if (value.certificateId == 1) {
                                } else {

                                    setValue(prev => ({ ...prev, totalInvoice: value.totalInvoice - value.fixedFee }))
                                    setValue(prev => ({ ...prev, fixedFee: 0 }))
                                }
                                if (!value.cityId) {
                                    var add = myAdds?.find(u => u.isDefault);
                                    //setValue(prev => ({ ...prev, orgTotalCost: value.totalCost }));
                                    if (add && addresses_cities1 != null) {
                                        setValue(prev => ({ ...prev, comment: "", addId: add?.id, addPhone: add?.addPhone, addName: add?.addName, cityNum: add?.city, streetNum: add?.street, buildingNum: add?.building, ncodeNum: add?.zipCode }))
                                        if (!add?.building) {
                                            setHouseNumIsNotProper(true);
                                        } else if (add?.building === "") {
                                            setHouseNumIsNotProper(true);
                                        } else if (isNumeric(add?.building)) {
                                            if (Number(add?.building) <= 999) {
                                                setHouseNumIsNotProper(false);
                                            } else
                                                setHouseNumIsNotProper(true);
                                        } else {
                                            setHouseNumIsNotProper(true);
                                        }
                                        var com = "";
                                        if (add?.comment) {
                                            setValue(prev => ({ ...prev, comment: add.comment }));
                                        }
                                        if (add?.city) {
                                            var cts = Object.keys(addresses_cities1);
                                            var cId = add?.city ? findIndex(cts, add.city.trim()) : -1;
                                            if (cId != -1) {
                                                var cName = add?.city;
                                                setValue(prev => ({ ...prev, cityId: cId }));
                                                if (cName) {

                                                    var strts = addresses_cities1["" + cName];
                                                    if (!strts)
                                                        strts = addresses_cities1[("" + cName).trim()];
                                                    var sts = [];
                                                    for (var i2 = 0; i2 < strts.length; i2++) {
                                                        sts.push({ id: i2, name: strts[i2], label: strts[i2] })
                                                    }
                                                    setAddStreets(sts);
                                                    var sId = add?.street ? findIndex(strts, add.street.trim()) : -1;
                                                    if (sId != -1) {
                                                        var sName = add?.street;
                                                        setValue(prev => ({ ...prev, streetId: sId }));
                                                    } else {
                                                        //cityNum: add?.city, streetNum: add?.street
                                                        com = add?.street;
                                                        setValue(prev => ({ ...prev, streetNum: null }));
                                                        setValue(prev => ({ ...prev, streetId: null }));
                                                        setValue(prev => ({ ...prev, comment: add.street }));
                                                    }
                                                }
                                            } else {
                                                setValue(prev => ({ ...prev, streetNum: null }));
                                                setValue(prev => ({ ...prev, cityNum: null }));
                                                setValue(prev => ({ ...prev, streetId: null }));
                                                setValue(prev => ({ ...prev, cityId: null }));
                                                setValue(prev => ({ ...prev, comment: add?.city + ", " + add.street }));

                                            }
                                        }
                                    }
                                }
                                setIsPreviewPdf(false)
                                setActiveScreen(screens[2].screen)
                            }
                        });
                        
                    }} />
                </Box>
            </Box>
            <Grid style={{ height: "60vh" }}></Grid>
        </Box>)

    const screen_c = (
        <Box className="reg_popup_data">

            {progressSteps(2)}

            {/*<Grid item lg={12} className="" alignContent="flex-start" justifyContent="flex-start" sx={{ marginTop: '-10px', fontSize: '14px !important' }}>
                <div onClick={() => setIsPreviewPdf(!isPreviewPdf)} style={{ marginLeft: "5px", backgroundImage: `url(${file})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '20px', }}></div>
            </Grid>*/}


            <Grid container item lg={12} >

                <Grid container item lg={12} className='label-wrapper'>
                    <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: 0 }}>
                        פרטי ההזמנה
                    </Grid>
                    <Grid className="popup_tittle sm" style={{ fontSize: '16px', marginBottom: 0 }}>
                        <div onClick={() => setIsPreviewPdf(!isPreviewPdf)} style={{ marginLeft: "5px", backgroundImage: `url(${file})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '20px', }}></div>  {uploadedPdfFileName}
                    </Grid>

                </Grid>

                <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>
                    {/*<Grid container item lg={4} sm={4} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>
                        <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>
                            עלות הפריטים:
                        </Grid>
                        <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                            {value.costOfItem}$
                        </Grid>

                    </Grid>
                    */
                    }
                    <Grid container item lg={4} sm={4} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>
                        <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>
                            סה״כ חשבונית
                        </Grid>
                        <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                            {value.totalCost} {currencies.find(u => u.id === value.selectedCurrency)?.symbol}
                        </Grid>
                        {false && <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                            {getConvertedCostByCurToNIS_UI(value.selectedCurrency ,value.totalCost).toFixed(2)} ₪
                        </Grid>}
                    </Grid>
                    {/*<Grid container item lg={4} sm={4} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>
                        <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>
                            סוג לקוח:
                        </Grid>
                        <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                            {isBusiness ? '' : 'פרטי'}
                        </Grid>
                    </Grid>*/}
                </Grid>
            </Grid>
            <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl', mt: 2 }}>

                <Grid container className='label-wrapper'>
                    <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: '8px' }}>
                        פרטי ההזמנה
                    </Grid>
                    <Grid container item lg={12} className="personal_popup_tittle" justifyContent="flex-start" alignContent="flex-start" style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        בחרו את סוג המשלוח {/*<div style={{ marginRight: "5px", backgroundImage: `url(${questionMark})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '16px' }}></div>*/}
                    </Grid>
                </Grid>

                <Box className='flex-rtl align-items-center mb-1rem' style={{ width: '100%' }}>
                    <Button className={`btn-radio  ${value.homeDelivary ? 'active active_home' : ''}`} onClick={() => {
                        setValue(prev => ({ ...prev, homeDelivary: true }));
                        var add = myAdds?.find(u => u.isDefault);
                        if (add?.comment) {
                            setValue(prev => ({ ...prev, comment: add.comment }));
                        }
                        if (add?.city) {
                            var cts = Object.keys(addresses_cities1);
                            var cId = findIndex(cts, add.city);
                            if (cId != -1) {
                                var cName = add?.city;
                                setValue(prev => ({ ...prev, cityId: cId }));
                                if (cName) {

                                    var strts = addresses_cities1["" + cName];
                                    var sts = [];
                                    for (var i2 = 0; i2 < strts.length; i2++) {
                                        sts.push({ id: i2, name: strts[i2], label: strts[i2] })
                                    }
                                    setAddStreets(sts);
                                    var sId = findIndex(strts, add.street);
                                    if (sId != -1) {
                                        var sName = add?.street;
                                        setValue(prev => ({ ...prev, streetId: sId }));
                                    } else {
                                        setValue(prev => ({ ...prev, streetId: null }));
                                        setValue(prev => ({ ...prev, streetNum: null }));
                                    }
                                }
                            } else {
                                setValue(prev => ({ ...prev, streetId: null }));
                                setValue(prev => ({ ...prev, cityId: null }));
                                setValue(prev => ({ ...prev, cityNum: null }));
                                setValue(prev => ({ ...prev, streetNum: null }));
                            }
                        }
                    }}>
                        {getTotalHmdCond() ? `משלוח עד הבית + 6$` :`משלוח עד הבית`}
                    </Button>
                    <Button disabled={checkWeight()} className={`btn-radio ${!value.homeDelivary ? 'active active_home' : ''}`} onClick={() => setValue(prev => ({ ...prev, homeDelivary: false }))}>
                        משלוח לנקודת איסוף
                    </Button>

                </Box>
                {value.homeDelivary && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '2vh' }}>
                    {myAdds.length > 0 && <Grid container item lg={12} className="personal_popup_tittle" justifyContent="flex-start" alignContent="flex-start" style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        בחר כתובת :{/*<div style={{ marginRight: "5px", backgroundImage: `url(${questionMark})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '16px' }}></div>*/}
                    </Grid>}
                    {myAdds.length > 0 && <Grid container item lg={7.3} justifyContent="flex-start">
                        <SelectField
                            className='text-field'
                            parentClassName={'select-field width-50 mar_10'}
                            dir="rtl"
                            required
                            value={value.addId}
                            onChange={event => {
                                setValue(prev => ({ ...prev, addId: event.target.value }));
                                var add = myAdds.find(u => u.id === event.target.value);
                                //setValue(prev => ({ ...prev, orgTotalCost: value.totalCost }));
                                setValue(prev => ({ ...prev, addPhone: add?.addPhone, addName: add?.addName, cityNum: add.city, streetNum: add.street, buildingNum: add.building, ncodeNum: add.zipCode }))
                                if (!add?.building) {
                                    setHouseNumIsNotProper(true);
                                } else if (add?.building === "") {
                                    setHouseNumIsNotProper(true);
                                } else if (isNumeric(add?.building)) {
                                    if (Number(add?.building) <= 999) {
                                        setHouseNumIsNotProper(false);
                                    } else
                                        setHouseNumIsNotProper(true);
                                } else {
                                    setHouseNumIsNotProper(true);
                                }
                                if (add?.comment) {
                                    setValue(prev => ({ ...prev, comment: add.comment}));
                                }
                                if (add?.city) {
                                    var cts = Object.keys(addresses_cities1);
                                    var cId = add?.city ? findIndex(cts, add.city.trim()) : -1;
                                    if (cId != -1) {
                                        var cName = add?.city;
                                        setValue(prev => ({ ...prev, cityId: cId }));
                                        if (cName) {

                                            var strts = addresses_cities1["" + cName];
                                            var sts = [];
                                            for (var i2 = 0; i2 < strts.length; i2++) {
                                                sts.push({ id: i2, name: strts[i2], label: strts[i2] })
                                            }
                                            setAddStreets(sts);
                                            var sId = add?.street ? findIndex(strts, add.street.trim()) : -1;
                                            if (sId != -1) {
                                                var sName = add?.street;
                                                setValue(prev => ({ ...prev, streetId: sId }));
                                            } else {
                                                setValue(prev => ({ ...prev, streetId: null }));
                                                setValue(prev => ({ ...prev, streetNum: null }));
                                            }
                                        }
                                    } else {
                                        setValue(prev => ({ ...prev, streetId: null }));
                                        setValue(prev => ({ ...prev, cityId: null }));
                                        setValue(prev => ({ ...prev, cityNum: null }));
                                        setValue(prev => ({ ...prev, streetNum: null }));
                                    }
                                }
                            }}
                            options={myAdds}
                            islabelAnimate={false}
                            isPrefix
                            isNumeric={true}
                            lg={7}
                            sx={{ mr: "0", maxWidth: "none !important" }}
                        />
                    </Grid>}
                    <Grid item sm={7} xs={8}>
                        <TextField
                            className='text-field short'
                            required
                            lg={6}
                            value={value.addName}
                            onChange={event => setValue(prev => ({ ...prev, addName: event.target.value }))}
                            label="שם *"
                            islabelAnimate={false}
                        />

                    </Grid>
                    <Grid item sm={7} xs={8}>
                        <TextField
                            className='text-field short'
                            required
                            lg={6}
                            value={value.addPhone}
                            onChange={event => setValue(prev => ({ ...prev, addPhone: event.target.value }))}
                            label="מספר נייד *"
                            islabelAnimate={false}
                            type="number"
                        />
                        {!validatePhone(value.addPhone) && value.addPhone && <Box className='col-md-12' style={{ direction: "rtl", color: "red", top: "-20px" }}>
                            מספר טלפון לא תקין
                        </Box>
                        }
                    </Grid>
                    <Grid item sm={7} xs={8}>
                        <SelectField
                            className='text-field'
                            required
                            value={value.cityId}
                            lg={6}
                            sx={{ margin: "2px" }}
                            style={{ direction: "rtl" }}
                            onChange={event => {
                                var city = addCities.find(u => u.id === event.target.value);
                                if (!city) {
                                    setAddressIsNotProper(true);
                                    setValue(prev => ({ ...prev, cityId: 0, streetId: 0 }));
                                    setValue(prev => ({ ...prev, cityNum: "" }));
                                    setValue(prev => ({ ...prev, streetNum: "" }));
                                    return;
                                }
                                setValue(prev => ({ ...prev, cityId: event.target.value }));
                                setValue(prev => ({ ...prev, cityNum: city.name }));

                                var strts = addresses_cities1["" + city.name];
                                var sts = [];
                                for (var i2 = 0; i2 < strts.length; i2++) {
                                    sts.push({ id: i2, name: strts[i2], label: strts[i2] });
                                }
                                setAddStreets(sts);
                                setValue(prev => ({ ...prev, streetNum: sts[0].name }));
                                setValue(prev => ({ ...prev, streetId: 0 }));
                            }}
                            options={addCities}
                            islabelAnimate={false}
                            parentClassName={'select-field'}
                            label="עיר"
                        />
                        {/*<TextField
                            className='text-field short'
                            required
                            lg={6}
                            value={value.cityNum}
                            onChange={event => setValue(prev => ({ ...prev, cityNum: event.target.value }))}
                            label="עיר *"
                            islabelAnimate={false}
                        />*/}
                        {!validateHebrewText(value.cityNum) && value.cityNum && <Box className='col-md-12' style={{ direction: "rtl", color: "red" }}>
                            המערכת תומכת בכתובת בעברית
                        </Box>
                        }
                    </Grid>
                    <Grid item sm={7} xs={8}>
                        <Grid item sm={12} xs={12}>
                            <SelectField
                                className='text-field'
                                required
                                value={value.streetId}
                                lg={12}
                                sx={{ margin: "2px" }}
                                onChange={event => {
                                    var street = addStreets.find(u => u.id === event.target.value);
                                    if (!street) {
                                        setAddressIsNotProper(true);
                                        setValue(prev => ({ ...prev, streetId: 0 }))
                                        return;
                                    }
                                    setValue(prev => ({ ...prev, streetId: event.target.value }));
                                    setValue(prev => ({ ...prev, streetNum: street.name }));
                                }}
                                options={addStreets}
                                islabelAnimate={false}
                                parentClassName={'select-field'}
                                label="רחוב"
                            />
                        </Grid>
                        {/*<TextField
                            className='text-field short'
                            required
                            lg={6}
                            value={value.streetNum}
                            onChange={event => setValue(prev => ({ ...prev, streetNum: event.target.value }))}
                            label="רחוב *"
                            islabelAnimate={false}
                        />*/}
                        {!validateHebrewText(value.streetNum) && value.streetNum && <Box className='col-md-12' style={{ direction: "rtl", color: "red" }}>
                            המערכת תומכת בכתובת בעברית
                        </Box>
                        }
                    </Grid>
                    <Grid item sm={7} xs={8}>

                        <TextField
                            className='text-field short'
                            required
                            lg={6}
                            value={value.buildingNum}
                            onChange={event => {
                                try {
                                    if (!event.target.value) {
                                        setValue(prev => ({ ...prev, buildingNum: event.target.value }))
                                        setHouseNumIsNotProper(true);
                                    } else if (event.target.value === "") {
                                        setValue(prev => ({ ...prev, buildingNum: event.target.value }))
                                        setHouseNumIsNotProper(true);
                                    } else if (isNumeric(event.target.value)) {
                                        if (Number(event.target.value) <= 999) {
                                            setValue(prev => ({ ...prev, buildingNum: event.target.value }))
                                            setHouseNumIsNotProper(false);
                                        }
                                    } else {
                                        setValue(prev => ({ ...prev, buildingNum: event.target.value }))
                                        setHouseNumIsNotProper(true);
                                    }
                                } catch (e) {
                                    setHouseNumIsNotProper(true);
                                }
                            }}
                            label="מספר בית - ספרות בלבד !"
                            type="text"
                            islabelAnimate={false}
                        />
                    </Grid>
                    {houseNumIsNotProper && <Box className='col-md-12' style={{ direction: "rtl", color: "red", top: "-20px" }}>
                        {`מספר בית - ספרות בלבד (0-999)`}
                    </Box>}
                    <Grid item sm={7} xs={8}>
                        <TextField
                            className='text-field short'
                            required
                            lg={6}
                            value={value.ncodeNum}
                            onChange={event => {
                                //setZipNumIsNotProper
                                setValue(prev => ({ ...prev, ncodeNum: event.target.value }))
                                function isNumeric(value) {
                                    return /^-?\d+$/.test(value);
                                }
                                try {
                                    if (event.target.value === "") {
                                        setValue(prev => ({ ...prev, ncodeNum: event.target.value }))
                                        setZipNumIsNotProper(false);
                                    } else if (isNumeric(event.target.value)) {
                                        if (event.target.value.length > 10) {
                                            setValue(prev => ({ ...prev, ncodeNum: event.target.value }))
                                            setZipNumIsNotProper(true);
                                        } else {
                                            setValue(prev => ({ ...prev, ncodeNum: event.target.value }))
                                            setZipNumIsNotProper(false);
                                        }
                                    } else {
                                        setValue(prev => ({ ...prev, ncodeNum: event.target.value }))
                                        setZipNumIsNotProper(true);
                                    }
                                } catch (e) {
                                    setZipNumIsNotProper(true);
                                }
                            }}
                            label="מיקוד - ספרות בלבד"
                            type="text"
                            islabelAnimate={false}
                        />
                        {(zipNumIsNotProper) && <Box className='col-md-12' style={{ direction: "rtl", color: "red", top: "-20px" }}>
                            { `מיקוד - יש להזין מספר באורך 7 ספרות`}
                        </Box>}
                    </Grid>
                    <Grid item sm={7} xs={8}>

                        <TextField
                            className='text-field short'
                            required
                            lg={6}
                            value={value.comment}
                            onChange={event => setValue(prev => ({ ...prev, comment: event.target.value.length < 100 ? event.target.value : event.target.value.substring(0, 100) }))}
                            label="מספר דירה , קומה וכניסה"
                            type="text"
                            islabelAnimate={false}
                        />
                    </Grid>
                </Grid>}
                {!value.homeDelivary && <Grid container item lg={12} justifyContent=" space-around" alignContent="flex-start" flexWrap="nowrap" sx={{ mt: '2vh' }}>
                    <SelectField
                        className='text-field baseSelctionList'
                        required
                        value={value.cityId}
                        lg={3}
                        sx={{ margin: "2px" }}
                        style={{ direction: "rtl" }}
                        onChange={event => {
                            var city = cities.find(u => u.id === event?.target?.value);
                            if (!city) {
                                setAddressIsNotProper(true);
                                setValue(prev => ({ ...prev, cityId: 0, streetId: 0, buildingId: 0 }))
                                return;
                            }
                            setAddressIsNotProper(false);
                            var t = [];
                            city?.streetList.map((d, index) => {
                                t.push({
                                    id: index + 1,
                                    name: d.streetName,
                                    ncode: d.ncode,
                                    houseList: d.houseList
                                });
                            })
                            t.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            setStreets(t);
                            setValue(prev => ({ ...prev, cityId: event.target.value, streetId: t[0].id, buildingId: 0 }))
                            //var street = t.find(u => u.id === t[0].id);
                            var t2 = [];
                            t[0]?.houseList.map((d, index) => {
                                t2.push({
                                    id: index + 1,
                                    name: d
                                });
                            })
                            t2.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            setBuildings(t2);
                            setValue(prev => ({ ...prev, buildingId: t2[0]?.id }))
                        }}
                        options={cities}
                        islabelAnimate={false}
                        parentClassName={'select-field'}
                        label="עיר"
                    />
                    <SelectField
                        className='text-field baseSelctionList'
                        required
                        value={value.streetId}
                        lg={3}
                        sx={{ margin: "2px" }}
                        onChange={event => {
                            var street = streets.find(u => u.id === event?.target?.value);
                            if (!street) {
                                setAddressIsNotProper(true);
                                setValue(prev => ({ ...prev, streetId: null, buildingId: null }))
                                return;
                            }
                            setAddressIsNotProper(false);
                            var t = [];
                            street?.houseList.map((d, index) => {
                                t.push({
                                    id: index + 1,
                                    name: d
                                });
                            })
                            t.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            setBuildings(t);

                            setValue(prev => ({ ...prev, streetId: event.target.value, buildingId: t[0]?.id }))
                        }}
                        options={streets}
                        islabelAnimate={false}
                        parentClassName={'select-field'}
                        label="רחוב"
                    />
                    <SelectField
                        className='text-field'
                        required
                        value={value.buildingId}
                        lg={3}
                        sx={{ margin: "2px" }}
                        onChange={event => {
                            var building = buildings.find(u => u.id === event?.target?.value);
                            if (!building && !event) {
                                setAddressIsNotProper(true);
                                setValue(prev => ({ ...prev, buildingId: null }))
                                return;
                            }
                            setAddressIsNotProper(false);
                            setValue(prev => ({ ...prev, buildingId: event.target.value }));
                        }}
                        options={buildings}
                        islabelAnimate={false}
                        parentClassName={'select-field'}
                        label="חנות"
                    />
                </Grid>}
                {addressIsNotProper && <Grid container item lg={12} justifyContent="space-evenly" alignContent="flex-start" sx={{ mt: '2vh', color: "#FF3452" }}>
                    { `הפרטים של נקודת החלוקה לא תקינים`}
                </Grid>}
                {value.homeDelivary &&<Box className='form-action' style={{}}>
                    <ActionButton disabled={addressIsNotProper || houseNumIsNotProper || zipNumIsNotProper} className={'submit-action'} textLabel={`שמירת כתובת`} onClick={() => {
                        if (!addressIsNotProper && !houseNumIsNotProper)
                            saveAddress();
                        else
                            dispatch(snackbarToggle({ type: 'error', message: `הפרטים של נקודת החלוקה לא תקינים` }));
                    }} />
                </Box>}
                {<Grid container item lg={12} flexWrap="nowrap" justifyContent="space-evenly" alignContent="center" alignItems="center" sx={{ mt: '2vh' }}>
                    <Grid item sm={8.2} xs={8}>
                        {selectedShipping?.params?.selectedBasePriceList?.length && selectedShipping?.params?.calculatedBasePrice && selectedShipping?.params?.transportVal_acc ? <TextField
                            className='text-field short'
                            readOnly={true}
                            lg={8}
                            value={"SHOES"}
                            onChange={event => {
                            }}
                            //onBlur={() => { calculate(value.subcategory - 1, value.couponText); }}
                            onBlur={() => {
                                // checkCoupon(value.couponText)
                            }}
                            label="קופון :"
                            islabelAnimate={false}
                        /> : < TextField
                            className='text-field short'
                            required
                            lg={8}
                            value={value.couponText}
                            onChange={event => {
                                setValue(prev => ({ ...prev, couponText: event.target.value }));
                                checkCoupon(event.target.value)
                                // calculate((value.subcategory - 1), event.target.value);
                            }}
                            //onBlur={() => { calculate(value.subcategory - 1, value.couponText); }}
                            onBlur={() => {
                                // checkCoupon(value.couponText)
                            }}
                            label="קופון :"
                            islabelAnimate={false}
                        />}
                        {/*< TextField
                            className='text-field short'
                            required
                            lg={8}
                            value={value.couponText}
                            onChange={event => {
                                setValue(prev => ({ ...prev, couponText: event.target.value }));
                                checkCoupon(event.target.value)
                                // calculate((value.subcategory - 1), event.target.value);
                            }}
                            //onBlur={() => { calculate(value.subcategory - 1, value.couponText); }}
                            onBlur={() => {
                                // checkCoupon(value.couponText)
                            }}
                            label="קופון :"
                            islabelAnimate={false}
                        />*/}
                    </Grid>
                    {<Grid item sm={6} xs={4} className="coupen_action">
                        {/*{value.couponText &&<Button variant='contained' sx={{ background: !checkCoupon() ? '#FF3452 !important' : '#00d707 !important' }} onClick={() => {*/}
                        {value.couponText && <Button variant='contained' sx={{ background: !validCoupon ? '#FF3452 !important' : '#00d707 !important' }} onClick={() => {
                            calculate(value.subcategory - 1, value.couponText, couponValue);
                        }} >
                            {!validCoupon ? <ClearIcon /> : <DoneIcon />}
                        </Button>
                        }
                    </Grid>
                    }
                </Grid>}
                <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start">

                    <Grid container className='label-wrapper' >
                        <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: '8px' }}>
                            סיכום
                        </Grid>
                    </Grid>
                    <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '2vh !important' }}>
                        <Grid container item xs={7} justifyContent="flex-start" alignContent="flex-start" >
                            { `מידות ס״מ`}
                        </Grid>
                        <Grid container item xs={5} justifyContent="flex-end" alignContent="flex-start" >
                            {getDimensions()}
                        </Grid>
                    </Grid>
                    <PaymentDetails userInfo={userInfo} selectedShipping={getSelectedShippingwithValue(selectedShipping, value)} />
                    
                    {/*<Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ }}>
                        <Grid container item xs={7} justifyContent="flex-start" alignContent="flex-start" >
                            { `משקל לחיוב`}
                        </Grid>
                        <Grid container item xs={5} justifyContent="flex-start" alignContent="flex-start" >
                            {getChWeight()}
                        </Grid>
                    </Grid>
                    <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ }}>
                        <Grid container item xs={7} justifyContent="flex-start" alignContent="flex-start" >
                            סה״כ עלויות שילוח
                        </Grid>
                        <Grid container item xs={5} justifyContent="flex-start" alignContent="flex-start" >
                            $  {Number(value.orgTotalCost).toFixed(2)}
                        </Grid>
                    </Grid>
                    {value.cD != 0 && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ }}>
                        <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" >
                            קופון
                        </Grid>
                        <Grid container item lg={5} xs={5} justifyContent="flex-start" alignContent="flex-start" >
                            $ {Number(value.cD).toFixed(2)} -
                        </Grid>
                    </Grid>
                    }
                    {value.homeDelivary && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '2vh !important' }}>
                        <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" >
                            משלוח עד הבית
                        </Grid>
                        <Grid container item lg={5} xs={5} justifyContent="flex-start" alignContent="flex-start" >
                            $ {getTotalHmdCond()?4:0}
                        </Grid>
                    </Grid>}*/}
                    <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start">
                        {/*<Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" >
                            מע"מ , עמלת שחרור ואגרת מכס
                        </Grid>
                        <Grid container item lg={5} xs={5} justifyContent="flex-start" alignContent="flex-start" >

                            $ {Number(Number(value.vat ? value.vat : 0) + Number(value.purchaseTax ? value.purchaseTax : 0) + Number(value.fixedFee ? value.fixedFee : 0) + Number(value.customsCharge ? value.customsCharge : 0)).toFixed(2)}
                        </Grid>
                        <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" >
                            שירותים נוספים
                        </Grid>
                        <Grid container item lg={5} xs={5} justifyContent="flex-start" alignContent="flex-start" >
                            $ {Number(value.addCharges ? (Number(value.addCharges) - Number(value.storageCost ? value.storageCost : 0)) : 0).toFixed(2)}
                        </Grid>

                        {(value.storageCost && Number(value.storageCost) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                            <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{  }}>
                                {'אחסנה'}
                            </Grid>
                            <Grid container item lg={5} xs={5} justifyContent="flex-start" alignContent="flex-start" sx={{ paddingLeft: "20px" }}>
                                $ {Number(value.storageCost).toFixed(2)}
                            </Grid>
                        </Grid> : <span></span>}*/}

                        {(Number(selectedShipping?.params?.userPaymentData.height) > 110 || Number(selectedShipping?.params?.userPaymentData["length"]) > 110 || Number(selectedShipping?.params?.userPaymentData.width) > 110) && <Grid container item lg={12} xs={12} justifyContent="flex-start" alignContent="flex-start" >
                            מידות חריגות של אחת מצלעות החבילה (מעל 110 ס"מ) תתווסף עלות של 40$.
                        </Grid>}
                    </Grid>
                    {/*<Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderTop: '1px solid gray', mt: '2vh !important' }}>
                        <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                            סה״כ שילוח ומיסים
                        </Grid>
                        <Grid container item lg={5} xs={5} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                            $ {
                                tempFunct()

                            }
                        </Grid>
                    </Grid>*/}
                </Grid>
            </Grid>
            <Box className='form-action' style={{marginBottom: "15vh"}}>
                {value.homeDelivary && <ActionButton disabled={gettingUpdatedValues || houseNumIsNotProper || !value.buildingNum || !value.cityNum || !validateHebrewText(value.cityNum) || !value.streetNum || !validateHebrewText(value.streetNum) || !value.addName || !value.addPhone || !validatePhone(value.addPhone)} className={'submit-action'} textLabel={'אישור והמשך תשלום'} onClick={() => {
                    checkForServiceAndOnHold(selectedShipping, function (state) {
                        if (state) {
                            if (value.homeDelivary) {
                                /*if (validateHebrewText(value.cityNum) || validateHebrewText(value.streetNum) || validateHebrewText(value.streetNum)) {
                                    dispatch(snackbarToggle({ type: 'error', message: "  רק תווים עבריים מותרים" }));
                                    return;
                                }*/
                                if (!value.buildingNum || !value.cityNum || !value.streetNum || !value.addName || !value.addPhone) {
                                    dispatch(snackbarToggle({ type: 'error', message: "Please enter Address" }));
                                    return;
                                } else if (value.ncodeNum.length > 7) {
                                    dispatch(snackbarToggle({ type: 'error', message: "Please check zip code" }));
                                    return;
                                }
                                handleUserData()
                            }
                            if (!value.homeDelivary) {
                                if (!value.cityId || !value.buildingId || !value.streetId) {
                                    dispatch(snackbarToggle({ type: 'error', message: "Please enter Address" }));
                                    return;
                                }
                                handleUserData()
                            }
                            setActiveScreen(4);
                        }
                    });

                }} />}
                {!value.homeDelivary && <ActionButton disabled={gettingUpdatedValues || !value.cityId || !value.buildingId || !value.streetId} className={'submit-action'} textLabel={'אישור והמשך תשלום'} onClick={() => {
                    
                    checkForServiceAndOnHold(selectedShipping, function (state) {
                        if (state) {
                            if (value.homeDelivary) {
                                if (!value.buildingNum || !value.cityNum || !value.streetNum || !value.addName || !value.addPhone) {
                                    dispatch(snackbarToggle({ type: 'error', message: "Please enter Address" }));
                                    return;
                                } else if (value.ncodeNum.length > 7) {
                                    dispatch(snackbarToggle({ type: 'error', message: "Please check zip code" }));
                                    return;
                                }
                                handleUserData()
                            }
                            if (!value.homeDelivary) {
                                if (!value.cityId || !value.buildingId || !value.streetId) {
                                    dispatch(snackbarToggle({ type: 'error', message: "Please enter Address" }));
                                    return;
                                }
                                handleUserData()
                            }
                            setActiveScreen(4);
                        }
                    });
                    

                }} />}
            </Box>
            <Grid style={{ height: "60vh" }}></Grid>
            {/*<Grid container item lg={12} style={{ fontSize: '16px', textDecoration: 'underline', cursor: 'pointer' }} justifyContent="center" alignContent="center" className="screen-footer scarlet" onClick={() => { }}>
                שמירת פרטים וביצוע תשלום מאוחר יותר
            </Grid>*/}
        </Box>)

    const screen_d = (
        <Box className="reg_popup_data" >

            <Grid item lg={12} className="popup_tittle" justifyContent="center" sx={{ marginTop: '20px', direction: "rtl", padding: 0 }}>
                <span className="\-">
                    {`רגע לפני התשלום`} <br />
                    {`מומלץ לבטח`}<br />
                    { `את החבילה שלך!`}
                </span>
            </Grid>
            {/*<Grid item lg={12} className="personal_popup_tittle" justifyContent="center" sx={{ marginTop: '5vh !important', fontSize: '1.7vh !important', fontWeight: 'bold !important' }}>
                שירות אריזה מחדש- חיסכון בעלות המשלוח
            </Grid>*/}
            {/*<Grid item lg={12} className="personal_popup_tittle" justifyContent="center" sx={{ marginTop: '0.2vh !important', fontSize: '1.7vh !important' }}>
                על ידי אריזה של המשלוח באופן יעיל יותר, וצמצום נפח האריזה ניתן לחסוך
                בעלויות השילוח. האריזה נעשית בצורה מקצועית אשר תשמור על המוצרים
                שלכם בעת השילוח. השירות ניתן בעלות של 4$.
            </Grid>*/}
            <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderRadius: "20px", backgroundColor: "#d7000742", mt: '2vh !important', direction: 'rtl' }}>
                <Grid container item lg={7} xs={7} alignItems="center" justifyContent="flex-start" alignContent="center" sx={{ fontWeight: 'bold', height: '50px', paddingRight: '25px' }}>
                    <Grid container item lg={12} style={{ flexWrap: 'nowrap', whiteSpace: 'nowrap', lineHeight: '24px' }}>
                        <DoneIcon className='red-tick' style={{ color: '#FF3452', paddingLeft: '5px' }} /> <span> מחיר המשלוח מיסים ואגרות :</span>
                    </Grid>
                </Grid>
                <Grid container item lg={5} xs={5} alignItems="center" justifyContent="flex-end" alignContent="center" sx={{ fontWeight: 'bold', height: '50px', paddingLeft: '25px' }}>
                    $ {Number(value.transportVal).toFixed(2)}
                </Grid>
            </Grid>
            {/* <Grid item lg={12} className="personal_popup_tittle" justifyContent="center" sx={{ marginTop: '0.2vh !important',direction:"rtl", fontSize: '1.7vh !important', fontWeight: 'bold !important' }}>
                ביטוח מוצר + {Number(0).toFixed(2)} $
             </Grid>*/}
            <Grid item lg={12} className="personal_popup_tittle" justifyContent="center" sx={{ marginTop: '0.2vh !important' }}>
                <span className="\-" style={{fontSize:"16px"}}>
                    { `הביטוח הינו אופציונאלי. אנא סמנו את בחירתכם לפני התשלום.`}
                </span>
            </Grid>
            <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderRadius: "20px", backgroundColor: "#d7000742", mt: '2vh !important', direction: 'rtl' }}>
                <Grid container item lg={7} xs={7} alignItems="center" justifyContent="flex-start" alignContent="center" sx={{ fontWeight: 'bold', height: '50px', paddingRight: '25px' }}>
                    <Grid container item lg={12} style={{ flexWrap: 'nowrap', whiteSpace: 'nowrap', lineHeight: '24px' }}>
                        {value.isInsurence && <DoneIcon className='red-tick' style={{ color: '#FF3452', paddingLeft: '5px' }} />}<span>ביטוח מוצר</span>
                    </Grid>
                </Grid>

                <Grid container item lg={5} xs={5} alignItems="center" justifyContent="flex-end" alignContent="center" sx={{ fontWeight: 'bold', height: '50px', paddingLeft: '25px' }}>
                    $ {Number(value.insurence).toFixed(2)}
                </Grid>
            </Grid>
            
            <Grid container item lg={12} justifyContent="flex-end" alignContent="flex-end" className="check-box" sx={{ mb: '3.64vh' }}>
               {/* disabled={isInsurenceDisabled}*/}
                {/*{(value.isInsurence && !isInsurenceDisabled) && <Button variant='contained' sx={{ mt: 2, width: '30%', background: 'white !important', borderRadius: '25.5px', height: '4.72vh', border: '1px solid #FF3452', color: "#FF3452" }} onClick={() => {*/}
                {/*{(value.isInsurence ) && <Button variant='contained' sx={{ mt: 2, width: '30%', background: 'white !important', borderRadius: '25.5px', height: '4.72vh', border: '1px solid #FF3452', color: "#FF3452" }} onClick={() => {
                    
                    setOpenInsuranceDialog(true);
                }} className="screen-footer-btn">
                    { `הוספה/הסרה`}
                </Button>
                }*/}
                { <Button variant='contained' sx={{ mt: 2, width: '30%', background: '#FF3452 !important', borderRadius: '25.5px', height: '4.72vh', border: '1px solid #FF3452' }} onClick={() => {
                    setOpenInsuranceDialog(true);
                }} className="screen-footer-btn">
                    { `הוספה/הסרה`}
                </Button>
                }
            </Grid>

            <Box className='form-action' style={{ marginTop: '40px' }}>
                <ActionButton disabled={gettingUpdatedValues || value.isInsurence == null} className={'submit-action'} textLabel={'אישור והמשך תשלום'} onClick={() => {
                    checkForServiceAndOnHold(selectedShipping, function (state) {
                        if (state) {
                            setActiveScreen(5);
                        }
                    });
                }} />
            </Box>
            <Box style={{height:"60vh"}}></Box>
        </Box>);


    const addStringDataFormanifest = (str1, str2) => {
        var n1 = str1 ? str1 : 0;
        var n2 = str2 ? str2 : 0;
        var num1 = Number(n1) ? Number(n1) : 0;
        var num2 = Number(n2) ? Number(n2) : 0;
        return Number(num1 + num2).toFixed(2);
    }
    const getExchangeRateByTrans = (nisVal, val) => {
        var v = Number(nisVal) / Number(val);
        if (!v) {
            v = 3.5
        }
        return Number(v).toFixed(2)
    }

    function insert(main_string, ins_string, pos) {
        if (!main_string)
            return "";
        if (typeof (pos) == "undefined") {
            pos = 0;
        }
        if (typeof (ins_string) == "undefined") {
            ins_string = '';
        }
        return main_string?.slice(0, pos) + ins_string + main_string?.slice(pos);
    }
    const screen_e = (
        <Box className="reg_popup_data">
            {progressSteps(3)}


            <Grid container item lg={12} className='label-wrapper' style={{ marginTop: '24px' }}>
                <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: 0 }}>
                    תשלום
                </Grid>
                <Grid></Grid>
            </Grid>
            <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>

                {(userInfo?.user?.setting?.TranzilaTK && (userInfo?.user?.setting?.expdate || (userInfo?.user?.setting?.expdateTK && userInfo?.user?.setting?.expdateTK !== "expdate"))) && <Box style={{ marginRight: "10px", height: '51px', padding: '18px 32px 20px', border: 'solid 1px #f0f0f2', backgroundColor: '#f6f6f6' }} className={value.payByToken ? 'Business selected_acc' : 'Business'} onClick={() => { setValue(prev => ({ ...prev, payByToken: true })) }}>
                    פרטי אשראי
                </Box>
                }
                <Box style={{ height: '51px', padding: '18px 32px 20px', border: 'solid 1px #f0f0f2', backgroundColor: '#f6f6f6' }} className={!value.payByToken ? 'Business selected_acc' : 'Business'} onClick={() => { setValue(prev => ({ ...prev, payByToken: false })) }}>
                    {!(userInfo?.user?.setting?.TranzilaTK && (userInfo?.user?.setting?.expdate || (userInfo?.user?.setting?.expdateTK && userInfo?.user?.setting?.expdateTK !== "expdate"))) ? 'תשלום באשראי' : "כרטיס אשראי"}
                </Box>
            </Grid>

            {value.payByToken && <Grid container justifyContent="space-between" sx={{ mt: 2 }}>

                <Grid container justifyContent="space-between" flexWrap={'nowrap'} sx={{ mt: 0 }}>
                    <img alt="" src={cardFromType(userInfo?.user?.setting?.TranzilaTK)} className="flag_img" style={{ paddingRight: '5px', height: "56px" }} />
                    <TextField
                        className='text-field-disabled'
                        required
                        value={`visa: ${insert(userInfo?.user?.setting?.ccno, "-", userInfo?.user?.setting?.ccno?.length - 4)}`}
                        onChange={() => { }}
                        label="מספר כרטיס אשראי"
                        readOnly={true}
                    />

                </Grid>
                {!userInfo.user.setting?.profileId && <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                    <TextField
                        className='text-field'
                        required
                        value={value.profileId}
                        onChange={event => setValue(prev => ({ ...prev, profileId: event.target.value }))}
                        label='תעודת זהות של בעל החשבון'
                    />
                </Grid>
                }
            </Grid>}
            {!value.payByToken && <><Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                <TextField
                    className='text-field'
                    required
                    value={value.cc_name}
                    onChange={event => {
                        setValue(prev => ({ ...prev, cc_name: event.target.value }));
                        setinValidCcName(true)
                    }}
                    onBlur={() => { setinValidCcName(true) }}
                    label='שם בעל הכרטיס'
                />
                {inValidCcName && !value.cc_name && <Box className='col-md-12' style={{ direction: "rtl", color: "red", top: "-20px" }}>
                    Invalid Name
                </Box>
                }
                <TextField
                    className='text-field'
                    required
                    value={value.myid}
                    onChange={event => {
                        setValue(prev => ({ ...prev, myid: event.target.value }));
                        if (!validateMyId(event.target.value)) {
                            setPaymentValidation(prev => ({ ...prev, bId: true }));
                            // if (value.myid)
                            // dispatch(snackbarToggle({ type: 'error', message: "Invalid Id." }));

                            return;
                        } else {
                            setPaymentValidation(prev => ({ ...prev, bId: false }));
                        }
                    }}
                    onBlur={event => {
                        if (!validateMyId(value.myid)) {
                            setPaymentValidation(prev => ({ ...prev, bId: true }));
                            // if (value.myid)
                            // dispatch(snackbarToggle({ type: 'error', message: "Invalid Id." }));

                            return;
                        } else {
                            setPaymentValidation(prev => ({ ...prev, bId: false }));
                        }
                    }}
                    label="תעודת זהות של בעל הכרטיס"
                    type="number"
                />
                {!validateMyId(value.myid) && value.myid && <Box className='col-md-12' style={{ direction: "rtl", color: "red", top: "-20px" }}>
                    Invalid ID
                </Box>
                }
                <Grid container justifyContent="space-between" flexWrap={'nowrap'} sx={{ mt: 0 }}>

                    <img alt="" src={cardFromNumber(value.ccno)} className="flag_img" style={{ paddingRight: '5px', height: "56px" }} />
                    <TextField
                        className='text-field'
                        required
                        value={value.ccno}
                        onChange={event => {
                            setValue(prev => ({ ...prev, ccno: event.target.value }));
                            setInValidCard(false);
                            setValue(prev => ({ ...prev, cctype: cardTextFromNumber(event.target.value) }))
                            validateCardNumber(event.target.value, function (bSucc, bIsra) {
                                if (!bSucc) {
                                    if (!bIsra)
                                        setPaymentValidation(prev => ({ ...prev, bCC: true }));
                                    else
                                        setPaymentValidation(prev => ({ ...prev, bCC: false }));
                                    if (value.ccno) {
                                        //dispatch(snackbarToggle({ type: 'error', message: "Invalid card." }));
                                        if (!bIsra)
                                            setInValidCard(true)
                                        return;
                                    }
                                } else {
                                    setPaymentValidation(prev => ({ ...prev, bCC: false }));
                                }
                                setBIsra(bIsra);
                            })
                        }}
                        label="מספר כרטיס אשראי"
                        type="number"
                        onBlur={event => {

                            setValue(prev => ({ ...prev, cctype: cardTextFromNumber(value.ccno) }))
                            validateCardNumber(value.ccno, function (bSucc, bIsra) {
                                if (!bSucc) {
                                    if (!bIsra)
                                        setPaymentValidation(prev => ({ ...prev, bCC: true }));
                                    else
                                        setPaymentValidation(prev => ({ ...prev, bCC: false }));
                                    if (value.ccno) {
                                        //dispatch(snackbarToggle({ type: 'error', message: "Invalid card." }));
                                        if (!bIsra)
                                            setInValidCard(true)
                                        return;
                                    }
                                } else {
                                    setPaymentValidation(prev => ({ ...prev, bCC: false }));
                                }
                                setBIsra(bIsra);
                            })
                        }}
                    />

                </Grid>
                {inValidCard && value.ccno && <Box className='col-md-12' style={{ direction: "rtl", color: "red", top: "-20px" }}>
                    Invalid card
                </Box>
                }
            </Grid>

                <Grid container justifyContent="space-between" flexWrap={'nowrap'} sx={{ mt: 2 }}>

                    <TextField
                        className='text-field'
                        required
                        value={value.mycvv}
                        onChange={event => {
                            setValue(prev => ({ ...prev, mycvv: event.target.value }));
                            if (event.target.value.length > 5) {
                                setPaymentValidation(prev => ({ ...prev, bCVV: true }));
                                return;
                            }
                            if (!checkCvvAndNumber(event.target.value, value.ccno)) {
                                setPaymentValidation(prev => ({ ...prev, bCVV: true }));
                                //dispatch(snackbarToggle({ type: 'error', message: "Invalid CVV." }));
                                return;
                            } else {
                                setPaymentValidation(prev => ({ ...prev, bCVV: false }));
                            }
                        }}
                        label="CVV"
                        parentClassName={'prefix-select width-30 no-input-pad'}
                        type="number"
                        onBlur={event => {
                            if (!checkCvvAndNumber(value.mycvv, value.ccno)) {
                                setPaymentValidation(prev => ({ ...prev, bCVV: true }));
                                //dispatch(snackbarToggle({ type: 'error', message: "Invalid CVV." }));
                                return;
                            } else {
                                setPaymentValidation(prev => ({ ...prev, bCVV: false }));
                            }
                        }}
                    />

                    <Box sx={{ direction: "rtl" }}>
                        <InputLabel sx={{ mr: 1.5 }}>
                            שנה
                        </InputLabel>
                        <SelectField
                            className='text-field padding_17'
                            required
                            value={value.selectedYear}
                            lg={12}
                            isNumeric={true}
                            onChange={event => {
                                var y = cc_years.find(u => u.id === event.target.value)?.name || "22";
                                var m = cc_months.find(u => u.id === value.selectedMonth)?.name || false;

                                if (!validateYear(y)) {
                                    setPaymentValidation(prev => ({ ...prev, bYear: true }));
                                    // dispatch(snackbarToggle({ type: 'error', message: "Invalid Year." }));
                                    return;
                                } else {
                                    setPaymentValidation(prev => ({ ...prev, bYear: false }));
                                }
                                setValue(prev => ({ ...prev, selectedYear: event.target.value }))
                                if (m) {
                                    if (!validateMonth(y, m)) {
                                        setPaymentValidation(prev => ({ ...prev, bMonth: true }));
                                        // dispatch(snackbarToggle({ type: 'error', message: "Invalid Month." }));
                                        return;
                                    } else {
                                        setPaymentValidation(prev => ({ ...prev, bMonth: false }));
                                    }
                                } else {
                                    setPaymentValidation(prev => ({ ...prev, bMonth: true }));
                                }

                            }}
                            sx1={{ padding: "17px" }}
                            sx={{ mt: -3.5 }}
                            options={cc_years}
                            islabelAnimate={false}
                            label="שנה"
                            parentClassName={'prefix-select width-100'}
                        />
                    </Box>
                    <Box sx={{ direction: "rtl" }}>
                        <InputLabel sx={{ mr: 1.5 }}>
                            חודש
                        </InputLabel>
                        <SelectField
                            className='text-field padding_17'
                            required
                            value={value.selectedMonth}
                            lg={3}
                            sx1={{ padding: "17px" }}
                            sx={{ mt: -3.5 }}
                            isNumeric={true}
                            onChange={event => {

                                setValue(prev => ({ ...prev, selectedMonth: event.target.value }))
                                var y = cc_years.find(u => u.id === value.selectedYear)?.name || "22";
                                var m = cc_months.find(u => u.id === event.target.value)?.name || "01";
                                if (!validateMonth(y, m)) {
                                    setPaymentValidation(prev => ({ ...prev, bMonth: true }));
                                    // dispatch(snackbarToggle({ type: 'error', message: "Invalid Month." }));
                                    return;
                                } else {
                                    setPaymentValidation(prev => ({ ...prev, bMonth: false }));
                                }
                            }}
                            options={cc_months}
                            islabelAnimate={false}
                            label="חודש"
                            parentClassName={'prefix-select width-100'}
                        />
                    </Box>
                </Grid>
                {!userInfo.user.setting?.profileId && <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                    <TextField
                        className='text-field'
                        required
                        value={value.profileId}
                        onChange={event => setValue(prev => ({ ...prev, profileId: event.target.value }))}
                        label='תעודת זהות של בעל החשבון'
                    />
                </Grid>
                }
                {(!checkCvvAndNumber(value.mycvv, value.ccno) || value.mycvv.length > 5) ? <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%" }}>
                    Invalid CVV
                </Box> : <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%" }}>

                </Box>
                }
                {paymentValidation.bYear ? <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%", marginLeft: "12%" }}>
                    Invalid Year
                </Box> : <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%", marginLeft: "12%" }}>

                </Box>
                }
                {paymentValidation.bMonth ? <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "22%", marginLeft: "5%" }}>
                    Invalid Month
                </Box> : <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%" }}>

                </Box>
                }
                <Grid container justifyContent="space-between" flexDirection="row-reverse" flexWrap={'nowrap'} sx={{ mt: 2 }}>
                    <Box container className='checkboxs'>
                        <FormControlLabel dir='rtl' key={uuidv4()} control={< Checkbox checked={value?.rememberPayment} onChange={event => setValue(prev => ({ ...prev, rememberPayment: event.target.checked }))} />} label={"שמור פרטי כרטיס"} />
                    </Box>
                </Grid>
            </>}
            { <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '2vh', direction: 'rtl' }}>
                <PaymentDetails userInfo={userInfo} selectedShipping={getSelectedShippingwithValue(selectedShipping, value)} />
            </Grid>}
            {false && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-end" className="check-box" sx={{ mb: 2 }}>
                <FormControlLabel className="check-box" key={uuidv4()} control={< Checkbox checked={value?.isCashBack} onChange={event => setValue(prev => ({ ...prev, isCashBack: event.target.checked }))} />} label={"רוצה לשלם עם ה Cash Back שלי (יתרה נוכחית 12$)"} />
            </Grid>
            }
            {!isFileUploaded && <Loader />}
            <Box className='form-action' style={{ marginTop: '40px', marginBottom: "15vh" }}>
                {/*{paymentValidation.bMonth.toString()} {paymentValidation.bYear.toString()} {paymentValidation.bCC.toString()} {paymentValidation.bCVV.toString()} {paymentValidation.bId.toString()}*/}
                {value.payByToken && <ActionButton disabled={gettingUpdatedValues || !userInfo.user?.setting?.TranzilaTK || !isFileUploaded} className={'submit-action'} textLabel={'תשלום'} onClick={() => {
                    shipping_pay_token();
                }} />
                }
                {/*{paymentValidation.bMonth.toString()} {paymentValidation.bYear.toString()} {paymentValidation.bCC.toString()} {paymentValidation.bCVV.toString()} {paymentValidation.bId.toString()}*/}
                {!value.payByToken && <ActionButton disabled={gettingUpdatedValues || !value.cc_name || paymentValidation.bMonth || paymentValidation.bYear || paymentValidation.bCC || paymentValidation.bCVV || paymentValidation.bId || !isFileUploaded} className={'submit-action'} textLabel={'תשלום'} onClick={() => {
                    shipping_pay();
                }} />}
            </Box>
            <Grid style={{ height: "60vh" }}></Grid>
        </Box>);

    const screen_f = (
        <Box className="reg_popup_data">
            <Grid container item lg={12} justifyContent="flex-end" alignContent="flex-end" className="personal_popup_tittle" sx={{ direction: 'rtl', mt: "8.7vh !important" }}>
                <Grid container item lg={4} className="" justifyContent="center">
                    <Grid item lg={12} className="" justifyContent="center">
                        <Button variant='contained' sx={{ border: "1px solid gray", color: "black", background: 'white !important', borderRadius: '25.5px', minWidth: '4.72vh', width: '4.72vh', minHeight: '4.72vh', height: '4.72vh' }} onClick={() => { setActiveScreen(screens[1].screen) }} className="screen-footer-btn">
                            <div style={{ marginTop: "25px", backgroundImage: `url(${checkMarkCopy})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '100%', height: '100%', }}></div>
                        </Button>
                    </Grid>
                    <Grid item lg={12} className="" justifyContent="center" sx={{ fontWeight: 'bold', marginTop: 1 }}>
                        {selectedShipping?.consolidationStatus == 3 ? 'העלאת חשבוניות' : 'העלאת חשבונית'}
                    </Grid>

                </Grid>
                <Grid container item lg={4} className="" justifyContent="center">
                    <Grid item lg={12} className="" justifyContent="center">
                        <Button variant='contained' sx={{ border: "1px solid gray", color: "black", background: 'white !important', borderRadius: '25.5px', minWidth: '4.72vh', width: '4.72vh', minHeight: '4.72vh', height: '4.72vh' }} onClick={() => { setActiveScreen(screens[1].screen) }} className="screen-footer-btn">
                            <div style={{ marginTop: "25px", backgroundImage: `url(${checkMarkCopy})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '100%', height: '100%', }}></div>
                        </Button>
                    </Grid>
                    <Grid item lg={12} className="" justifyContent="center" sx={{ fontWeight: 'bold', marginTop: 1 }}>
                        השלמת פרטי משלוח
                    </Grid>

                </Grid>
                <Grid container item lg={4} className="" justifyContent="center">
                    <Grid item lg={12} className="" justifyContent="center">
                        <Button variant='contained' sx={{ border: "1px solid gray", color: "black", background: 'white !important', borderRadius: '25.5px', minWidth: '4.72vh', width: '4.72vh', minHeight: '4.72vh', height: '4.72vh' }} onClick={() => { setActiveScreen(screens[2].screen) }} className="screen-footer-btn">
                            {screens[2].screen}
                        </Button>
                    </Grid>
                    <Grid item lg={12} className="" justifyContent="center" sx={{ fontWeight: 'bold', marginTop: 1 }}>
                        תשלום
                    </Grid>
                </Grid>
            </Grid>
            <Grid item lg={12} className="popup_tittle" justifyContent="flex-end" sx={{ marginTop: '5vh !important' }}>
                תשלום
            </Grid>
            <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>
                <Grid item lg={6} className={true ? 'Business selected_acc' : 'Business'} onClick={() => { }}>
                    תשלום באשראי
                </Grid>
            </Grid>

            <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                <Grid item lg={12} >
                    <TextField
                        className='text-field'
                        required
                        lg={12}
                        value={value.cardHolder}
                        onChange={event => setValue(prev => ({ ...prev, cardHolder: event.target.value }))}
                        label="שם מלא של בעל הכרטיס"
                    />
                </Grid>
                <Grid item lg={12} >
                    <TextField
                        className='text-field'
                        required
                        lg={12}
                        value={value.cardHolderId}
                        onChange={event => setValue(prev => ({ ...prev, cardHolderId: event.target.value }))}
                        label="תעודת זהות של בעל הכרטיס"
                    />
                </Grid>
                <Grid item lg={12} >
                    <TextField
                        className='text-field'
                        required
                        lg={12}
                        value={value.creditCardNum}
                        onChange={event => setValue(prev => ({ ...prev, creditCardNum: event.target.value }))}
                        label="מספר כרטיס אשראי"
                    />
                </Grid>
            </Grid>
            <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                <Grid item lg={3} >
                    <TextField
                        className='text-field'
                        required
                        lg={12}
                        value={value.cvv}
                        onChange={event => setValue(prev => ({ ...prev, cvv: event.target.value }))}
                        label="CVV"
                    />
                </Grid>
                <SelectField
                    required
                    value={value.selectedYear}
                    lg={3}
                    onChange={event => setValue(prev => ({ ...prev, selectedYear: event.target.value }))}
                    label=''
                    options={sleeps}
                />
                <SelectField
                    required
                    value={value.selectedMonth}
                    lg={3}
                    onChange={event => setValue(prev => ({ ...prev, selectedMonth: event.target.value }))}
                    label=''
                    options={months}
                />
            </Grid>

            <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '2vh', direction: 'rtl' }}>

                <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '1vh !important' }}>
                    <Grid container item lg={7} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                        סה״כ עלויות שילוח
                    </Grid>
                    <Grid container item lg={5} justifyContent="flex-end" alignContent="flex-start" >
                        81.90 $
                    </Grid>
                </Grid>
                <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '1vh !important' }}>
                    <Grid container item lg={7} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                        שירותים נוספים
                    </Grid>
                </Grid>
                <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '1vh !important' }}>
                    <Grid container item lg={7} justifyContent="flex-start" alignContent="flex-start" >
                        משלוח עד הבית
                    </Grid>
                    <Grid container item lg={5} justifyContent="flex-end" alignContent="flex-start" >
                        4 $
                    </Grid>
                </Grid>
                <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '1vh !important' }}>
                    <Grid container item lg={7} justifyContent="flex-start" alignContent="flex-start" >
                        חסכון
                    </Grid>
                    <Grid container item lg={5} justifyContent="flex-end" alignContent="flex-start" >
                        8-$
                    </Grid>
                </Grid>
                <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderTop: '1px solid gray', mt: '2vh !important' }}>
                    <Grid container item lg={7} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                        סה״כ לתשלום
                    </Grid>
                    <Grid container item lg={5} justifyContent="flex-end" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                        77.90$
                    </Grid>
                </Grid>
            </Grid>
            <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" className="check-box" sx={{ mb: '3.64vh' }}>
                <Button variant='contained' sx={{ marginLeft: 2, fontWeight: 'normal !important', mt: 2, width: '50%', background: 'white !important', borderRadius: '25.5px', height: '4.72vh', border: '1px solid #80808029', color: "black" }} onClick={() => { }} className="screen-footer-btn">
                    הזן קוד קופון
                </Button>
                <Button variant='contained' sx={{ fontWeight: 'normal !important', mt: 2, width: '30%', background: 'white !important', borderRadius: '25.5px', height: '4.72vh', border: '1px solid #FF3452', color: "#FF3452" }} onClick={() => { }} className="screen-footer-btn">
                    הפעלה
                </Button>
            </Grid>
            <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-end" className="check-box" sx={{ mb: 2 }}>
                <FormControlLabel className="check-box" key={uuidv4()} control={< Checkbox checked={value?.isCashBack} onChange={event => setValue(prev => ({ ...prev, isCashBack: event.target.checked }))} />} label={"רוצה לשלם עם ה Cash Back שלי (יתרה נוכחית 12$)"} />
            </Grid>
            <Grid container item lg={12} justifyContent="center" alignContent="center" className="check-box" >
                <Button variant='contained' sx={{ mt: 2, width: '90%', background: '#FF3452 !important', borderRadius: '25.5px', height: '4.72vh', border: 'none' }} onClick={() => { setActiveScreen(screens[2].screen) }} className="screen-footer-btn">
                    תשלום
                </Button>
            </Grid>
        </Box>);

    const screen_H = (
        <Box className="reg_popup_data">
            <Grid container item lg={12} className='label-wrapper' style={{ marginTop: '24px', alignItems: 'center', flexDirection: 'column' }}>
                <Grid><DoneIcon style={{ fontSize: '24px', fontWeight: 'bolder', color: '#FF3452' }} /></Grid>
                <Grid className="popup_tittle lg" >
                    {'התשלום בוצע בהצלחה!'} <br /> {`עוד קצת והחבילה אצלך :)`}
                </Grid>
                <Grid style={{ fontSize: '18px', lineHeight: '1.2', textAlign: 'center', marginTop: '10px' }}>
                    {`ניתן בכל עת לעקוב אחר סטטוס המשלוח `} <br /> {`באזור האישי`}
                </Grid>
            </Grid>


            <Box className='form-action' style={{ marginTop: '80px' }}>
                <ActionButton className={'submit-action'} textLabel={`חזרה לאיזור האישי`} onClick={() => {
                    setIsPersonal(false);
                    window.location.reload();
                    /*ping(userInfo.session, function (response) {
                        setIsPersonal(false);
                    })*/
                }} />
            </Box>
        </Box>);
    const isKiosk = (data) => {
        return !data.params.homeDelivary && data.params.homeDelivary_nis == 0;
    }
    const getCity = (data) => {
        return data.params?.userPaymentData?.destPickup?.City;
    }
    const getStreet = (data) => {
        return data.params?.userPaymentData?.destPickup?.Street;
    }
    const getHome = (data) => {
        return data.params?.userPaymentData?.destPickup?.House;
    }
    const screen_e_preview = (
        <Box className="reg_popup_data">
            {(selectedShipping?.shippingStatus == 201 || (selectedShipping?.shippingStatus == 203 && (selectedShipping?.oldShippingStatus == 1 || selectedShipping?.oldShippingStatus == 2))) ?
                <Grid className="popup_tittle lg" style={{ marginTop: "250px" }} >{ `.צור קשר עם שרות לקוחות`}</Grid>
                :
                <Grid container itme style={{}}>
                    {!selectedShipping?.params?.statusLog && <Grid container className="screen-progress-steps">
                        {screens.map((val, index) =>
                            <Box key={val.screen + index} className={`progress-step done`}>
                                <Box className="step-circle">
                                    {val.screen}
                                </Box>
                                <Box className="step-title">
                                    {val.title}
                                </Box>
                            </Box>)}
                    </Grid>
                    }

                    <Grid item container style={{ direction: "rtl", fontWeight: "bold", fontSize: "23px", color:"#FF3452" }} justifyContent="flex-start">
                        {`חבילה מס׳`} {selectedShipping.hawb}
                    </Grid>
                    <Grid container item lg={12} className='label-wrapper' style={{ marginTop: '20px' }}>
                        <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: 0 }}>
                            תשלום
                        </Grid>
                    </Grid>


                    <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '0', direction: 'rtl' }}>
                        {(data.shippingStatus != 203 || (data.shippingStatus == 203 && (selectedShipping.oldShippingStatus == 3 || selectedShipping.oldShippingStatus == 4 || selectedShipping.oldShippingStatus == 5))) && < Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '0', direction: 'rtl' }}>
                            <PaymentDetails userInfo={userInfo} selectedShipping={selectedShipping} />
                            <Grid item container style={{ marginTop: "30px" }} flexDirection="column" alignItems="flex-start">
                                <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: 0 }}>
                                    {`כתובת למשלוח`}
                                </Grid>
                                {isKiosk(selectedShipping) && <Grid style={{ marginTop: "10px" }}>
                                    <p style={{ fontWeight: "bold", margin: 0 }}>{`נקודת איסוף`}</p>
                                    <p style={{ margin: 0 }}>{getCity(selectedShipping)}</p>
                                    <p style={{ margin: 0 }}>{getStreet(selectedShipping)}</p>
                                    <p style={{ margin: 0 }}>{getHome(selectedShipping)}</p>
                                </Grid>}
                                {!isKiosk(selectedShipping) && <Grid style={{ marginTop: "10px" }}>
                                    <p style={{ margin: 0 }}>{getCity(selectedShipping)}, {getStreet(selectedShipping)} {getHome(selectedShipping)}</p>
                                </Grid>}
                            </Grid>
                        </Grid>}
                        {selectedShipping.shippingStatus == 302 && <Box className="dropzone-area" style={{marginTop: "2vh"}} >
                            {/*{<Box className="dropzone-area" >*/}
                            <Grid container className="upload-content">
                                <div {...getRootProps({
                                    onClick: (event) => {
                                        if (checkFiles()) {
                                            event.stopPropagation();
                                        }
                                    }
                                })} className='upload-area'>
                                    <input {...getInputProps()} />
                                    {
                                        <Grid container className="upload-content">
                                            <img className='upload' src={upload} alt='upload' />
                                            {selectedShipping.consolidationStatus == 3 && uploadedOrgFiles?.length > 0 && !checkFiles() && <Box className="content-line-1">
                                                ניתן להעלות מספר חשבוניות
                                            </Box>}
                                            {selectedShipping.consolidationStatus == 3 && uploadedOrgFiles?.length > 0 && checkFiles() && <Box className="content-line-1">
                                                החשבוניות עלו בהצלחה
                                            </Box>}
                                            <Box className="content-line-1" style={{ direction: "rtl", textAlign: "right" }}>
                                                {`להעלאת חשבונית הקנייה`} <a style={{ textDecoration: "underline", color: "#FF3452" }}>{`לחץ כאן`}</a> {`>>>`}
                                            </Box>
                                            <Box className="content-line-1" style={{ direction: "rtl" }}>
                                                <span>
                                                    ניתן להעלות קבצים מסוג JPEG, PNG, BMP, PDF עד גודל 2MB
                                                </span>
                                                <p style={{marginTop: "15px"}}>
                                                    { `על החשבונית לכלול את הפרטים הבאים: שם המוכר, שם הקונה, תיאור המוצרים ועלותם. מומלץ להעלות כקובץ PDF`}
                                                </p>
                                            </Box>
                                        </Grid>
                                    }
                                </div>
                            </Grid>
                        </Box>}
                        {selectedShipping?.params?.statusLog && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '4vh !important' }}>
                            <Grid container item lg={12} className='label-wrapper' style={{ marginTop: '24px' }}>
                                <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: 0 }}>
                                    פרטים
                                </Grid>
                            </Grid>
                            {true && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '3vh !important' }}>
                                <Grid flexWrap="nowrap" container className="screen-progress-steps" style={{ justifyContent: 'flex-start' }}>
                                    <Box className={`progress-step1 ${(getStatusById(1) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                        <Box className={`step-circle ${(getStatusById(1) ? 'red_back' : '')}`}>
                                            {getStatusById(1) ? <FaCheck /> : 1}
                                        </Box>
                                        <Box className="step-title" style={{ textAlign: "inherit" }}>
                                            תשלום
                                        </Box>

                                    </Box>
                                    {/*<hr class="divider" />*/}
                                    <Box className={`progress-step1 ${(getStatusById(2) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                        <Box className={`step-circle ${(getStatusById(2) ? 'red_back' : '')}`} >
                                            {getStatusById(2) ? <FaCheck /> : 2}
                                        </Box>
                                        <Box className="step-title" style={{ textAlign: "inherit" }}>
                                            המשלוח בטיפול
                                        </Box>
                                    </Box>
                                    {/* <hr class="divider" />*/}
                                    <Box className={`progress-step1 ${(getStatusById(3) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                        <Box className={`step-circle ${(getStatusById(3) ? 'red_back' : '')}`}>
                                            {getStatusById(3) ? <FaCheck /> : 3}
                                        </Box>
                                        <Box className="step-title" style={{ textAlign: "inherit" }}>
                                            {`בדרך לארץ`}
                                        </Box>
                                    </Box>
                                    <Box className={`progress-step1 ${getStatusById(6) ? 'done_back' : ''}`} style={{ marginTop: "10px" }}>
                                        <Box className={`step-circle ${getStatusById(6) ? 'red_back' : ''}`}>
                                            {getStatusById(6) ? <FaCheck /> : 4} {/*5*/}
                                        </Box>
                                        <Box className="step-title" style={{ textAlign: "inherit" }}>
                                            נמסר להפצה
                                        </Box>
                                    </Box>
                                    {/*<hr class="divider" />*/}
                                    <Box className={`progress-step1 ${(getStatusById(7) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                        <Box className={`step-circle ${(getStatusById(7) ? 'red_back' : '')}`}>
                                            {getStatusById(7) ? <FaCheck /> : 5} {/*6*/}
                                        </Box>
                                        <Box className="step-title" style={{ textAlign: "inherit" }}>
                                            משלוח נמסר
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>}
                            <Grid container item lg={12} spacing={1} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                    תאריך
                                </Grid>
                                <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                    תיאור
                                </Grid>
                            </Grid>
                            {selectedShipping?.params?.statusLog?.map((val, index) => <>
                                {(val.DESC && (val.id == 3 && selectedShipping?.parentId == 0 ? selectedShipping?.params?.shippingStatus : true)) && <Grid container item lg={12} spacing={1} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                    <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                        {getDateFormat(val.DATE)}
                                    </Grid>
                                    <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                        {val.DESC} 
                                    </Grid>
                                </Grid>
                                }
                            </>)}
                            {selectedShipping.parentId == 0 && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                    {getDateFormat(selectedShipping.create_date)}
                                </Grid>
                                <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                    {`ההזמנה נקלטה במערכת`} {selectedShipping?.parentId == 0 ? " - ORCA Market" : ""}
                                </Grid>
                            </Grid>}
                        </Grid>}
                        {(selectedShipping.consolidationStatus == 3 && !selectedShipping?.params?.notes?.includes("Repack Service:")) &&

                            <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                    איחוד חבילות:
                                </Grid>
                                <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                    {selectedShipping?.params?.notes?.replace("Repack:", "").replaceAll("Old", "Original")}
                                </Grid>
                            </Grid>
                        }
                        {false && selectedShipping.repackStatus == 104 &&

                            <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                    צמצום נפח:
                                </Grid>
                                <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                    {selectedShipping?.params?.notes?.replace("Repack:", "").replaceAll("Old", "Original")}
                                </Grid>
                            </Grid>
                        }
                        <Grid style={{height: "90vh"}}></Grid>
                    </Grid>
                </Grid>}
        </Box>);
    return (

        <DialogWithSideBar
            open={isPersonal}

            onClose={() => {
                //if (activeScreen != 8) {
                //    onHandleOpenModal()
                //} else {
                    setIsPersonal(false)
                //}
            }}
            isBackButton={activeScreen == 4 || activeScreen == 5 || activeScreen == 6}
            onClickBack={() => setActiveScreen(activeScreen - 1)}
        >
            {openOrderModal && (
                <Dialog maxWidth='sm' open={openOrderModal} title={``} onHandleCancel={onHandleCancelModal}>

                    <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                        ? האם להמשיך
                    </Grid>
                    <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} onClick={() => {
                        setIsPersonal(false)
                    }}>המשך</Button>
                    <Button sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} variant='contained' onClick={onHandleCancelModal}> בטל</Button>
                </Dialog>
            )}
            {openInsuranceDialog &&
                <Dialog maxWidth='sm' open={openInsuranceDialog} title={`ביטוח`} onHandleCancel={onHandleCancelInsuranceDialog}>
                    <Grid container item justifyContent="center" sx={{ fontSize: "20px", direction: "rtl", margin: "5px" }}>
                        <p style={{margin:"10px"}}>{`שימו לב, ללא הביטוח לא תהיו זכאים לפיצוי במקרה של אבדן או נזק לחבילה בתהליך השילוח או ההפצה בארץ על ידי חברת ההפצה.`}</p>
                    </Grid>
                    <Grid item container justifyContent= "center">
                        <Button sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px 10px" }} variant='contained' onClick={() => {
                            setValue(prev => ({ ...prev, isInsurence: false }));
                            onHandleCancelInsuranceDialog();
                        }}>
                            {`לא רוצה ביטוח`}
                        </Button>
                        <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px 10px" }} onClick={() => {
                            setValue(prev => ({ ...prev, isInsurence: true }));
                            onHandleCancelInsuranceDialog();
                        }}>{`רוצה ביטוח`}</Button>
                    </Grid>
                </Dialog>
            }
            {openOrderModalDelete && (
                <Dialog maxWidth='sm' open={openOrderModalDelete} title={``} onHandleCancel={onHandleCancelModalDelete}>

                    <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                        ? האם להמשיך
                    </Grid>
                    <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} onClick={() => {
                        deleteSelectdReciept(selectedRecieptName)
                    }}>המשך</Button>
                    <Button sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} variant='contained' onClick={onHandleCancelModalDelete}> בטל</Button>
                </Dialog>
            )}

            {activeScreen == 1 && <Fragment>
                {screen_A}
            </Fragment>
            }
            {activeScreen == 2 && <Fragment>
                {screen_b}
            </Fragment>
            }
            {activeScreen == 3 && <Fragment>
                {screen_c}
            </Fragment>
            }
            {activeScreen == 4 && <Fragment>
                {screen_d}
            </Fragment>
            }
            {activeScreen == 5 && <Fragment>
                {screen_e}
            </Fragment>
            }
            {false && <Fragment>
                {screen_f}
            </Fragment>
            }
            {activeScreen === 8 && <Fragment>
                {screen_H}
            </Fragment>
            }
            {activeScreen === 9 && <Fragment>
                {screen_e_preview}
            </Fragment>
            }

            {isPreviewPdf && <Box className="reg_popup_data left-side">
                <Grid container item lg={1} justifyContent="flex-end" alignContent="flex-end" sx={{ mt: '2vh !important', fontSize: "24px", fontWeight: "bold", color: "#FF3452", cursor: "pointer" }} onClick={() => { setIsPreviewPdf(false) }}>
                    X
                </Grid>
                <Grid container item lg={12} justifyContent="center" alignContent="center" sx={{ mt: '2vh !important', fontSize: "24px", fontWeight: "bold", color: "#FF3452" }}>
                    חשבונית הקנייה
                </Grid>

                <Grid container item lg={11} justifyContent="flex-start" alignContent="flex-start" sx={{ m: '2vh !important', color: '#FF3452', fontSize: "14px", fontWeight: "bold" }} alignItems="center">
                    <Grid onClick={() => {
                        setActiveScreen(screens[0].screen); setIsPreviewPdf(false)
                        setValue(prev => ({ ...prev, category: 0 }))
                        setValue(prev => ({ ...prev, subcategory: 0 }))
                    }} container item lg={4} justifyContent="flex-start" alignContent="flex-start" sx={{ color: '#FF3452', fontSize: "14px", fontWeight: "bold" }}>
                        {/* */}  העלאת קובץ חדש
                        <div style={{ paddingLeft: "10px" }}>
                            <img className='upload' src={upload} alt='upload' />
                        </div>
                    </Grid>

                    {selectedShipping.consolidationStatus == 3 &&<Grid container item lg={4} justifyContent="flex-end" alignContent="flex-end" sx={{ fontSize: "14px" }} className="personalFileReciept">
                        <SelectField
                            className='text-field1'
                            required
                            value={uploadedPdfBse64Id}
                            onChange={event => {
                                setUploadedPdfBse64Id(event.target.value)

                                var filePdf = uploadedOrgFilesBase64.find(u => u.id === event.target.value);
                                setUploadedPdfBse64(filePdf)
                            }}
                            label=''
                            options={uploadedOrgFilesBase64}
                            islabelAnimate={false}
                            isPrefix
                            parentClassName={'select-field '}
                            dir="rtl"
                            isNumeric={true}
                            sx={{ m: 0, mr: "10px", height: "30px" }}
                        />
                    </Grid>
                    }

                    <Grid container item lg={4} justifyContent="flex-end" alignContent="flex-end" sx={{ fontSize: "14px" }}>
                        <span sx={{ fontSize: "14px", fontWeight: "bold" }}>{uploadedPdfBse64?.name}</span>:
                        <span>שם הקובץ</span>
                    </Grid>
                </Grid>

                {/*{uploadedOrgFilesBase64.map((val, index) =>
                    <iframe src={`data:application/pdf;base64,${val.base64}`}
                        frameBorder="0" style={{ "height": "calc(100% - 300px)", "width": "100%", "top": "0px", "left": "0px", "right": "0px", "bottom": "0px" }} />

                )}*/}
                {/*<iframe src={`/shipping/getRecieptUserUploaded/${userInfo.session}/${selectedShipping.hawb}/${uploadedPdfBse64?.name}#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;`}
                    frameBorder="0" style={{ "minHeight": "calc(100% - 225px)", "width": "100%", "top": "0px", "left": "0px", "right": "0px", "bottom": "0px" }} />
*/}
                {/*<iframe src={`data:application/pdf;base64,${uploadedPdfBse64?.base64}#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;`}
                    frameBorder="0" style={{ "minHeight": "calc(100% - 225px)", "width": "100%", "top": "0px", "left": "0px", "right": "0px", "bottom": "0px" }} />*/}
                {/*<iframe src={uploadedPdf}
                    frameBorder="0" style={{ "height": "calc(100% - 155px)", "width": "100%", "top": "0px", "left": "0px", "right": "0px", "bottom": "0px" }} />*/}

                <Grid item container justifyContent="center">
                    {/* The file name must be encoded: names like "order #123.pdf" were cut at '#'
                        (the server URL-decodes it). Photos are shown as images — react-pdf can't open them. */}
                    {/\.(jpe?g|png|gif|webp|heic)$/i.test(uploadedPdfBse64?.name || '')
                        ? <img alt="" style={{ maxWidth: "100%", height: "auto" }}
                            src={`/shipping/getRecieptUserUploaded/${userInfo.session}/${selectedShipping.hawb}/${encodeURIComponent(uploadedPdfBse64?.name || '')}`} />
                        : <Document file={`/shipping/getRecieptUserUploaded/${userInfo.session}/${selectedShipping.hawb}/${encodeURIComponent(uploadedPdfBse64?.name || '')}`}>
                            <Page pageNumber={1} renderTextLayer={false} renderAnnotationLayer={false} />
                        </Document>}
                </Grid>
                <Grid item container justifyContent="center">
                    <Button textLabel={`המשך`} style={{ background: "#FF3452", color: "white", fontWeight: "bold", fontSize: "16px", borderRadius: "30px",height: "50px", padding:"0 100px"}} onClick={() => {
                        setIsPreviewPdf(!isPreviewPdf)
                    }} >{`המשך`} </Button>
                </Grid>
            </Box>}
        </DialogWithSideBar>
    );
}

export default Personal;